module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Revelation")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CHTitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "FirstPara5"
  }, [_vm._v("The book of Revelation is the most sensual document in the NT, filled with references to things seen, heard, smelled, touched, and even tasted! Its holistic sensory invitation has proven to be an embrace hard to resist for many, whether they be artists, musicians, preachers, filmmakers, visionaries, revolutionaries, ascetics, or religious enthusiasts. Yet its wide appeal, particularly on a popular level, is met with a skeptical response on the part of many with academic training in theology, who often write the book off as the domain of the lunatic fringe. For it is at the same time a book that purports to reveal things that shall soon take place, but its message is conveyed in such symbolic and cosmic language that there are nearly as many interpretations of the book as there are interpreters!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The purpose of this introduction is to aid readers in their reading of the text of Revelation and the commentary that follows. Here we give primacy of place to the text of the book and the introductory issues that arise from the text. The introduction begins with a section devoted to the structure and nature of Revelation, which gives way to an examination of what can be known about the audience of this book, and then on to issues of date and authorship. Owing to the effect of this text upon a wide variety of individuals, the introduction concludes with a section identifying some of the major streams of influence that can be traced back to Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle2",
    attrs: {
      "id": "in01"
    }
  }, [_vm._v("Structure and Nature of the Book")])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Revelation is perhaps the most literarily complex and sophisticated document in the NT. A close reading reveals a vast array of extraordinarily impressive literary devices, which testify to the intricate design and brilliance of the ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("work.")]), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1"
    }
  }, [_vm._v("1")])]), _vm._v(" When discussing the literary character and structure of Revelation, it is important to remember that the document was apparently written to be heard while it was being read aloud (1:3). Part of the genius of the work is that the clues as to its structure seem to communicate at a couple of different levels. On the one hand, some of the literary devices are apparent on one’s first exposure to the document; on the other hand, many of these dimensions emerge slowly as the book is repeatedly read and heard over a prolonged period of time. Like so many other aspects of the text of Revelation, the blessing promised to those who hear the words of this prophecy promises more than meets the eye (or ear, in this case). It is not an overstatement to say that each hearing or reading of Revelation brings discoveries of connections and nuances previously unnoticed. Given the breadth and depth of its imagery, little wonder that it has fueled the imagination of so many interpreters.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in02"
    }
  }, [_c('i', [_vm._v("Literary Markers Recognized by a First-Time Hearer of Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Several aspects of the structure emerge after an initial encounter with the text of Revelation. It is clear from an initial hearing of the book that Revelation begins with a prologue. From this prologue the hearer learns that this Apocalypse of Jesus Christ, given by God to John, is a prophecy that results in a blessing for those who read, hear, and keep the things written in it (1:3). After these initial words, the prologue proceeds with a formula normally found at the beginning of an epistle. Here the standard A (author) to B (recipient) greeting occurs, with John being identified as the author, and the seven churches in Asia as the recipients. The greeting continues in expanded Christian fashion with the bestowal of grace and peace upon the readers. The prologue moves to a doxology and concludes with two prophetic words.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another feature of the book’s structure, apparent from an initial encounter with the text, is the role and prominence of the Spirit. Soon after mention of the seven spirits before the throne (1:4), a pattern begins to emerge in which the Spirit plays a significant role. At four strategic locations (1:10; 4:2; 17:3; 21:10) the phrase "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν πνεύµατι")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("en pneumati,")])]), _vm._v(" “in the Spirit”) occurs. Each occurrence "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("stands at the beginning of a new section of the book, and together they serve as the major structural markers in Revelation. Significantly, this phrase appears for the first time immediately after the close of the prologue.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Other major structural components one encounters in an initial hearing of Revelation are several series of sevens. There are seven prophetic messages to the seven churches of Asia (2:1–3:22), seven seals (6:1–8:5), seven trumpets (8:6–11:19), and seven plagues (15:1–16:21).")]), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2"
    }
  }, [_vm._v("2")])]), _vm._v(" Obviously, these series are an important dimension of the text and contribute something to the overall structure of the book. In this regard, the first series of seven (messages) are unnumbered in their delineation and are not formally connected to the other series of sevens. It is also significant that this first series of sevens is followed immediately by the second occurrence of the phrase "), _c('i', [_vm._v("en pneumati")]), _vm._v(" (“in the Spirit”), indicating the beginning of a new section of Revelation. The other three series of sevens are each individually enumerated in their description (first, second, third, etc.), and each of these series is formally connected to the others. To illustrate by means of computer software language, when one clicks on the icon of the seventh seal, the seven trumpets appear (8:1-2). Likewise, though not quite as explicit, when one clicks on the icon of the seventh trumpet (11:15-19), following the interlude of chapters 12–14, the seven bowls emerge (15:1). Thus, it would appear that these three series of sevens stand together structurally in the book. Confirming this idea is, immediately after the seventh bowl of plagues is poured out, the phrase "), _c('i', [_vm._v("en pneumati")]), _vm._v(" occurring for a third time, indicating the onset of the next major section in Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Additional structural markers that first-time hearers of Revelation will notice come in the form of the interludes that appear between the sixth and seventh seals (7:1-17) and between the sixth and seventh trumpets (10:1–11:14). In each case, these interludes seem to interrupt the flow of the document, at the least delaying the action being described. At the same time, such interludes draw attention to significant theological aspects of the text."), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3"
    }
  }, [_vm._v("3")])]), _vm._v(" Similarly, chapters 12–14 appear to interrupt the flow of the document, dividing the description of the seven trumpets (8:6–11:19) from that of the seven bowls (15:1–16:21). While chapters 12–14 do interrupt the flow of the document, they do have a structural significance, for they are connected thematically to the first two interludes, and the story line of 12–14 converges in 15:1 with the story line left off at 11:19. Suffice it to say at this point that these interludes would also make a structural impression upon first-time hearers of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Near the end of the book the hearer encounters a contrast between two cities: Babylon, the great whore (17:1–21:8), and New Jerusalem, the bride of Christ (21:9–22:5). These sections are each marked by one of the seven angels with bowls of plagues speaking to John (17:1; 21:9), the phrase "), _c('i', [_vm._v("en pneumati")]), _vm._v(" (“in the Spirit,” 17:3; 21:10), and near-identical introductory statements (17:1-3; 21:9-10). Thus, the climax of the book is reached with a description of the destruction of Babylon and the descent from heaven and description of the New Jerusalem.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A final structural dimension of Revelation readily distinguishable to the first-time hearer is the book’s concluding epilogue (22:6-21). Not only does the epilogue serve as a balance to the opening prologue, but numerous terms and themes found in the prologue also reappear in the epilogue, offering an inclusio effect for the hearer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The following structure emerges from the above clues available to first-time hearers:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb1"
  }, [_vm._v("1:1-8"), _c('span', {
    staticClass: "space"
  }), _vm._v("   Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("1:9–3:22"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("“In the Spirit on the Lord’s Day”")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("1:9-20"), _c('span', {
    staticClass: "space"
  }), _vm._v("The Inaugural Vision of Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("2:1–3:22"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("The Seven Prophetic Messages to the Seven Churches of Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("2:1-7"), _c('span', {
    staticClass: "space"
  }), _vm._v("To the Angel of the Church in Ephesus")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("2:8-11"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("To the Angel of the Church in Smyrna")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("2:12-17"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("To the Angel of the Church in Pergamum")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("2:18-29"), _c('span', {
    staticClass: "spacec"
  }), _vm._v("   To the Angel of the Church in Thyatira")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("3:1-6"), _c('span', {
    staticClass: "space"
  }), _vm._v("To the Angel of the Church in Sardis")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("3:7-13"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("To the Angel of the Church in Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("3:14-22"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("To the Angel of the Church in Laodicea")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("4:1–16:21"), _c('span', {
    staticClass: "spacec"
  }), _vm._v("“In the Spirit in Heaven”")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("4:1–5:14"), _c('span', {
    staticClass: "space1"
  }), _vm._v("The Inaugural Vision of Heaven, the One Who Sits on the Throne, the Lamb, and the Scroll Sealed with Seven Seals")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("6:1–8:5"), _c('span', {
    staticClass: "space1"
  }), _vm._v("  The Opening of the Scroll Sealed with Seven Seals")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("6:1-17"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("The Opening of the First Six Seals")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("7:1-17"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("The Interlude of the 144,000 and the Great Multitude")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("8:1-5"), _c('span', {
    staticClass: "space"
  }), _vm._v("The Opening of the Seventh Seal and the Golden Altar")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("8:6–11:19"), _c('span', {
    staticClass: "space1a"
  }), _vm._v("Seven Angels with Seven Trumpets")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("8:6–9:21"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" The Sounding of the First Six Trumpets")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("10:1–11:14 The Interlude of the Little Scroll and the Two Witnesses")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("11:15-19"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" The Sounding of the Seventh Trumpet")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("12:1–14:20"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("The Struggle of God’s People in Cosmic Perspective")])]), _c('p', {
    staticClass: "Hang2"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("12:1–13:1a  Signs in Heaven: The Woman Clothed with the Sun, and the Red Dragon")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "Hang2"
  }, [_vm._v("13:1b-18"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" The Two Beasts")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("14:1-20"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("The Lamb and the 144,000, the Harvest and the Winepress")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("15:1–16:21  Seven Angels with Seven Bowls of Plagues")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("15:1-8"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("Another Great Sign in Heaven: The Seven Angels")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("16:1-21"), _c('span', {
    staticClass: "space1"
  }), _vm._v(" The Pouring Out of the Seven Bowls")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("17:1–21:8"), _c('span', {
    staticClass: "spacec"
  }), _vm._v("  “In the Spirit” — Carried to a Wilderness")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("17:1-18"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("The Woman on the Beast: Babylon the Whore")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("18:1-24"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("The Destruction of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("19:1–21:8"), _c('span', {
    staticClass: "spacec"
  }), _vm._v("From Babylon the Great to the New Jerusalem — from the Last Judgment to the New Creation")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("19:1-10"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("Rejoicing in Heaven and on Earth and the Marriage Supper of the Lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("19:11-16"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" The King of Kings and Lord of Lords")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("19:17-21"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" Victory over the King’s Enemies")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("20:1-6"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("  The Thousand-Year Reign")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("20:7-10"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("Satan’s Final Rebellion and Defeat")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("20:11-15"), _c('span', {
    staticClass: "spacec"
  }), _vm._v(" The Final Judgment")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("21:1-8"), _c('span', {
    staticClass: "spacea"
  }), _vm._v("The Descent of the New Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("21:9–22:5"), _c('span', {
    staticClass: "space1"
  }), _vm._v("“In the Spirit” — Carried to a Great High Mountain: The Description of the New Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("22:6-21"), _c('span', {
    staticClass: "spaceb"
  }), _vm._v("  Epilogue")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Given this basic structure, which emerges from an initial exposure to Revelation, what other significant elements may be discerned from a more intensive engagement with the text? In addition to this broad structure, there are a number of places where the whole document, large sections, or smaller sections are connected to one another by means of similar or, in some cases, identical vocabulary or themes. For example, a comparison of the language of 1:1-3 with that of 22:6-7 reveals that these verses constitute an inclusio that bounds the entire book.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("The revelation of Jesus Christ, which God gave him to show his servants what must soon take place. He made it known by sending his angel to his servant John, who testifies to everything he saw — that is, the word of God and the testimony of Jesus. Blessed is the one who reads the words of this prophecy, and blessed are those who hear it and take to heart what is written in it, because the time is near. (1:1-3)")])]), _c('p', {
    staticClass: "QuoteSb12"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("The angel said to me, “These words are trustworthy and true. The Lord, the God of the spirits of the prophets, sent his angel to show his servants the things that must soon take place.” “Behold, I am coming soon! Blessed is he who keeps the words of the prophecy in this book.” (22:6-7)")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("A variety of terms used to describe Christ near the beginning of the book — “his eyes were like flames of fire” (1:14; 2:18), “from his mouth came a sharp two-edged sword” (1:16; 2:12, 16), he will rule “with an iron scepter” (2:26-27), he is the “faithful and true witness” (3:14) — converge in one passage near its end in describing the King of Kings and Lord of Lords (19:11-16). A final example of a literary device that serves to hold the entire book together is the occurrence of seven beatitudes, found at various places throughout the book (1:3; 14:13; 16:15; 19:9; 20:6; 22:7, 14).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not only does one find techniques that help knit the entire book together, one also sees a similar phenomenon within a major section of the book. An example occurs in 4:1–16:21. This section, which is devoted primarily to the three series of sevens, is held together in part by a recurring phrase that expands in intensity as the section unfolds. Specifically, the “flashes, sounds, and thunder” that come from the throne in 4:5 become the “thunder, sounds, flashes, and earthquake” that come to earth from heaven when the angel casts down fire from the altar in 8:5. And then when God’s temple in heaven opens in 11:19, there come “flashes, sounds, thunder, earthquake, and great hail.” This recurring theme culminates in 16:18-21 when, after a voice from the throne says “It is done,” there come “flashes, sounds, thunder,” an earthquake greater than any experienced on earth before, and hailstones weighing 100 pounds ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ταλαντιαία")]), _vm._v(", "), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("talantiaia")])]), _vm._v(") each. Significantly, these phenomena do not occur together elsewhere in the book. Similarly, the interlude of chapters 12–14 is bounded on either side by great signs in the heavens. The interlude begins with “a great sign was seen in heaven” (12:1), and its conclusion gives way to “and I saw another great and marvelous sign in heaven” (15:1). In like fashion the ending of one section and beginning of another section can be conveyed by the occurrence of the same phrase on two separate occasions. The close of the central major section (4:1–16:21) and beginning of the next section (17:1–21:8) are signaled by the appearance of “It is done” in 16:17, while the close of the latter and beginning of the final major section in the book (21:9–22:5) are likewise signaled by “It is done,” in 21:6. Additionally, the same term can occur in a given section to convey a sense of movement from one ultimate domain to another. On seven occasions beginning with 13:1 through 15:2, the term "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἶδον")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("eidon")])]), _vm._v(" “I saw”) occurs and is used to convey a sense of movement from the sea, beside which the dragon stood, to the sea of glass, beside which stood those who had been victorious over the beast. The text says:")])]), _c('p', {
    staticClass: "HangSb2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("And I saw a beast coming "), _c('i', [_vm._v("out of the sea.")]), _vm._v(" (13:1)")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw another beast coming "), _c('i', [_vm._v("out of the earth.")]), _vm._v(" (13:11)")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw . . . the Lamb standing "), _c('i', [_vm._v("upon Mount Zion.")]), _vm._v(" (14:1)")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw another angel flying "), _c('i', [_vm._v("in mid-air.")]), _vm._v(" (14:6)")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw . . . one like the Son of Man sitting "), _c('i', [_vm._v("upon a cloud.")]), _vm._v(" (14:14)")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw another great and marvelous sign "), _c('i', [_vm._v("in heaven.")]), _vm._v(" (15:1)")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb2a"
  }, [_vm._v("And I saw what looked like "), _c('i', [_vm._v("a sea of glass, beside which")]), _vm._v(" were standing those who had been victorious over the beast. (15:2)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Another characteristic of the literary structure of Revelation is, on at least three occasions, two sections that come together at a transition point in the book overlapping with one another. This is the case where the seven seals give way to the seven trumpets (8:1-5), where the story line of the cosmic interlude converges with the story line of the seven bowls of plagues (15:1-4), and where the description of the New Jerusalem gives way to the epilogue (22:6-11). Such phenomena remind the hearer that, while major movements within the book may be discerned, the document stands together as a single visionary drama.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in03"
    }
  }, [_c('i', [_vm._v("Revelation as Visionary Drama")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Insofar as, through repeated hearings and readings of the book, the structure of Revelation emerges as a visionary drama, what would be conveyed to its hearers with regard to the kind of literature that is being heard and read? While differing aspects of this question receive more extensive treatment below, it is important initially to gain a sense of the way in which a hearer may have understood the document as a whole.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("One of the first things evident to the hearer about the literary nature of Revelation is that it is designed for “oral enactment.”")]), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" While it is legitimate to note that the document had to be read publicly owing to John’s absence on Patmos, such an explanation of the act of reading does not take into sufficient account the dramatic characteristics of Revelation. At every turn, there are indications that the book is designed for oral enactment."), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Evidence for this observation includes many of the literary features noted in the discussion with regard to the book’s structure, but it is not confined to them. In addition "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("to the utilization of various numbered series (sevens, threes, and twos), the multiple use of the "), _c('i', [_vm._v("en pneumati")]), _vm._v(" (“in the Spirit”) phrase, and the employment of periodic interludes, there are numerous other indicators. For example, the images and places used to convey the message of the book are both intriguing and memorable. To this feature we might add the first person address of both John and Jesus, the generous use of hymns, and, at each stage of the book, a fuller revelation about Jesus. The liberal use of colors in Revelation tends to confirm that the work is designed for oral enactment. By way of illustration, the relatively colorless Fourth Gospel, which mentions only white and purple, pales in comparison with the colors of Revelation, which include gold/yellow, white, scarlet, red, purple, silver, green, and black. Given the dramatic characteristics of Revelation, some interpreters have gone so far as to argue that it was constructed to be staged in ways not unlike the Greek tragedies.")]), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The point of these observations is to underscore the fact that, first and foremost, the hearers and readers of Revelation would have experienced this document as the oral enactment of a visionary drama. It is important to take up the issue at this point, for discussions that attempt to ascertain the literary genre of Revelation sometimes lose sight of this rather basic understanding of the document.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Part of the power of this visionary drama is that it creates for its hearers and readers a symbolic world offering an alternate version of reality to that experienced by the Asian churches in the Roman world."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7"
    }
  }, [_vm._v("7")])]), _vm._v(" This alternate reality offers heaven as the vantage point from which to assess the reality of this world and its powers. The significance of such an alternate reality is difficult to overestimate, for it empowers its hearers and readers to confront their present reality as faithful witnesses who have an active role to play in the conversion of the nations, which lies before them. But there is more. The hearers and readers are not only invited to hear or view this symbolic world, but also to experience it by means of participation. For throughout this oral enactment, the hearers and readers find themselves responding vicariously along with John as he turns, sees, hears, and looks. As the visions of the one who sits on the throne and of the Lamb unfold, the hearers and readers find themselves in the spontaneous acts of worship that erupt on numerous occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The logical place for such oral enactment is the context of worship within the "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("community. Not only would this be consistent with the common practice found across early Christianity of reading significant communiqués before the entire community (1 Thess 5:27; Eph 6:21; Col 4:16; Phlm 2), but it would also be the most appropriate context for hearing, testing, and discerning prophetic utterances. This would be true both of prophetic utterances of a spontaneous nature and of prophetic messages (including visions) that, while experienced outside the context of the community’s worship, would be brought to it for the appropriate response.")]), _c('a', {
    attrs: {
      "id": "fn8"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This phenomenological understanding of Revelation, as orally enacted visionary drama, goes a long way toward defining for the hearers and readers the kind of literature Revelation is. Within this understanding of how the hearers and readers would experience Revelation as visionary drama, other questions with regard to the issue of the literary genre of the book may be pursued.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Technically, this visionary drama takes the form of a circular letter to the seven churches of Asia (1:4, 11; 22:16). The book bears the marks of the standard A (author) to B (recipient) greeting near the beginning of the book (1:4) and concludes with the epistolary formula “May the grace of the Lord Jesus be with you all” (22:21). Although the content of Rev 2–3 is sometimes described as the seven letters to the seven churches, in point of fact Revelation is a single circular letter that includes seven prophetic messages to the seven churches of Asia. This literary device means that, while each church is informed by the specific message addressed to it, at the same time they are all informed by "), _c('i', [_vm._v("all")]), _vm._v(" the prophetic messages, which are to be read by all the churches. The theological reason that such a visionary drama takes the form of an epistle is owing to the command received by John in his inaugural vision.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("That which you see, write in a book and send it to the seven churches, to Ephesus and to Smyrna and to Pergamum and to Thyatira and to Sardis and to Philadelphia and to Laodicea. (1:11)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Among other things, the epistolary form, as does the command to write in a book everything seen, serves to reinforce the idea that this visionary drama stands together and is to be heard and read as a whole. John is told at the beginning to write down in a book all the things he sees, which conveys to the hearers and readers that John is to embark on a journey. For those who care to join him in this journey, perhaps his book will give the impression of being a travelogue."), _c('a', {
    attrs: {
      "id": "fn9"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('i', [_vm._v("Revelation as Christian Prophecy")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("A number of indicators in the text reveal that this visionary drama, which takes the form of a circular letter, is a piece of early Christian prophecy. Such an identification comes very early in the book, where John describes the volume as “the words of this prophecy” (1:3). This description is repeated near the close of the book as well, where again Revelation is referred to as “the words of this prophecy” (22:7). These phrases form an inclusio that bounds the book on either side, indicating how the entire epistle is to be heard and read. This identification of Revelation as a prophecy is also confirmed by the words of the angel who instructs John, “Do not seal up the words of this prophecy” (22:10). Finally, the book closes with a set of warnings that further underscore the book’s description of itself as a prophetic book.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("I witness (to) all who hear the words of the prophecy of this book: if anyone adds unto them, God will add upon them the plagues written (described) in this book. And if anyone takes away from the words of the book of this prophecy, God will take away his part of the tree of life and the city of the saints (holy ones), which are written (described) in this book. (22:18-19)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Not only does the book describe itself as prophecy, but also a number of passages in the book look very much to be individual prophetic utterances. These include the following:")])]), _c('ul', {
    staticClass: "disc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('li', [_vm._v("the words of God in 1:8 — “I am the Alpha and Omega . . . who is, and who was, and who is to come”;")]), _vm._v(" "), _c('li', [_vm._v("the prophetic messages of Jesus to the seven churches in 2:1–3:22;")]), _vm._v(" "), _c('li', [_vm._v("the words of the Spirit in 14:13 — “Yes,” says the Spirit, “in order that they might rest from their labor; for their works follow after them”;")]), _vm._v(" "), _c('li', [_vm._v("the words of Jesus in 16:15 — “Behold, I come as a thief! Blessed is the one who stays awake and keeps one’s garments (pure), in order that he might not walk naked and they see his private parts”; and")])]), _c('li', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("the numerous words of Jesus in 22:7-20.")]), _c('a', {
    attrs: {
      "id": "fn10"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("In addition to the overt descriptions of the book as prophecy and examples of prophetic utterances in the book, several textual indicators suggest that the context from which the book originates is itself a prophetic one. Mention is "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("made in the book of at least one rival prophet(ess) (2:20). Other statements make it clear that John does not function alone in his prophetic activity, for he and others are addressed near the end of Revelation by an angel who says, “I am a fellow servant with you and your brothers the prophets” (22:9). This same group (possibly including the OT prophets) may well be in view a few verses earlier when the angel makes reference to “the Lord, the God of the spirits of the prophets” (22:6). Other references to these prophets in Revelation include 11:18; 16:6; 18:20, 24 (cf. also references to prophets in 10:7 and 11:10). Taken together, this textual evidence makes one thing very clear: the prophecy that is Revelation comes from a prophetic community. This fact, in and of itself, would add some understanding to the public reading of “the words of this prophecy” to the community.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Finally, it should also be noted that this prophecy has a number of affinities with OT prophecy. Not only does Revelation resemble a number of OT prophetic books in formal ways (i.e., by inclusion of call narratives and the emphasis upon the Word of God and the visions),")]), _c('a', {
    attrs: {
      "id": "fn11"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11"
    }
  }, [_vm._v("11")])]), _vm._v(" but it also exhibits a similar prophetic consciousness on the part of the author."), _c('a', {
    attrs: {
      "id": "fn12"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12"
    }
  }, [_vm._v("12")])]), _vm._v(" In fact, it appears that John so sees himself as heir to the OT prophetic tradition that he, as the OT prophets before him, inherits earlier prophecies, the reinterpretation of which figures prominently in his own prophecy. This may be illustrated by the way in which the prophecy concerning Babylon in Rev 18:1–19:8 echoes every message against Babylon found in the OT, as well as two messages against Tyre."), _c('a', {
    attrs: {
      "id": "fn13"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Owing to the many similarities between Revelation and the OT prophetic tradition, John’s own sense of prophetic consciousness, and the scope and magnitude of Revelation, one writer has described the book as “the climax of prophecy.”"), _c('a', {
    attrs: {
      "id": "fn14"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in05"
    }
  }, [_c('i', [_vm._v("Revelation and the Apocalyptic Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("It is also clear from several aspects of the text of Revelation that there is some kind of relationship between Revelation and the apocalyptic tradition. In fact, for some interpreters the evidence for this is so strong that it is not uncommon to find commentaries that address the issue of apocalyptic as its first order of "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("business.")]), _c('a', {
    attrs: {
      "id": "fn15"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15"
    }
  }, [_vm._v("15")])]), _vm._v(" What evidence is there for seeing a relationship between the two, and what is the nature of the relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Perhaps one of the most significant clues that Revelation has strong connections to the apocalyptic tradition is its being the first document we know of to use the word "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀποκάλυψις")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("apokalypsis,")])]), _vm._v(" “revelation”) as part of its title. Whatever the relationship between this book of prophecy and the apocalyptic tradition may be, many later documents follow Revelation in using the word "), _c('i', [_vm._v("apokalypsis")]), _vm._v(" as part of its title. While there is some debate as to the precise meaning of the phrase “an apocalypse of Jesus Christ” (an issue that will be addressed later), it should be noted that there is some degree of circularity in assuming that this document, from which an entire genre of literature takes its name, is an apocalyptic document, merely because the word “apocalypse” is part of its title."), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Assessing the nature of the relationship between Revelation and the apocalyptic tradition is complicated because the broad boundaries and specific characteristics of the apocalyptic genre are anything but fixed; they are still greatly debated within the scholarly community."), _c('a', {
    attrs: {
      "id": "fn17"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17"
    }
  }, [_vm._v("17")])]), _vm._v(" Despite the inherent obstacles involved in ascertaining the relationship between Revelation and the apocalyptic tradition, perhaps the following observations will be of some assistance in sorting out this difficult issue.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, it should be noted that Revelation is similar to the apocalyptic tradition in several respects. The fantastic imagery employed in Revelation, among other things, reminds one of the imagery of a number of other apocalyptic documents. This similarity suggests, at the least, that Revelation and a variety of apocalyptic documents draw from the same conceptual well."), _c('a', {
    attrs: {
      "id": "fn18"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Like the broader apocalyptic tradition, Revelation conveys a transcendent perspective about this world and its history, allowing hearers and readers the opportunity to view this world and its history from the perspective of heaven. Revelation also shares with other apocalyptic documents an interest in the question, Who is Lord over the world?"), _c('a', {
    attrs: {
      "id": "fn19"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19"
    }
  }, [_vm._v("19")])]), _vm._v(" In addition, Revelation is decidedly eschatological in orientation."), _c('a', {
    attrs: {
      "id": "fn20"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("At the same time, there are decided differences between Revelation and what has come to be known as the apocalyptic tradition. One of the best-known differences is that the author of Revelation writes in his own name, unlike the documents normally considered as part of the apocalyptic tradition, which are pseudonymous with regard to authorship. If Revelation is to be considered as part of the apocalyptic tradition, it stands virtually alone in this regard.")]), _c('a', {
    attrs: {
      "id": "fn21"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21"
    }
  }, [_vm._v("21")])]), _vm._v(" Perhaps this anomaly is to be explained by John’s considering his work to be a book of prophecy, or perhaps it has something to do with his closer temporal proximity to the time of Jesus’ earthly ministry.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another difference between Revelation and the apocalyptic tradition is evident in the use of visual symbolism. Generally speaking, there is more visual symbolism in Revelation than (other) apocalyptic texts. At the same time, there is a virtual absence of angelic interpretation present in Revelation, as opposed to other apocalypses. Additionally, the generally short and self-contained vision normally found in only one part of an apocalyptic document virtually encompasses the whole of this one. A final difference is that, unlike the book of Daniel, for example — where Daniel is instructed by the angel to “close up and seal up the words of the scroll until the time of the end. . . . Go your way, Daniel, because the words are closed up and sealed until the end of time” (Dan 12:4, 9) — John is instructed, “Do not seal up the words of the prophecy of this book, because the time is near” (Rev 22:10)."), _c('a', {
    attrs: {
      "id": "fn22"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22"
    }
  }, [_vm._v("22")])]), _vm._v(" Revelation is an open book rather than a closed one.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given the differences and similarities of Revelation to the apocalyptic tradition, what might be concluded about the nature of their relationship? It is important to remember that the hearers and readers of this book would not make the kind of hard and fast distinctions between the prophetic and apocalyptic genres that contemporary students of Scripture sometimes do."), _c('a', {
    attrs: {
      "id": "fn23"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23"
    }
  }, [_vm._v("23")])]), _vm._v(" It is clear that John and his hearers would be familiar with a number of the symbols, imagery, and language found in apocalyptic documents of the time. However, the use of similar imagery does not necessarily imply a literary dependence but suggests that these ideas were in the air breathed by John and his audience. They often draw from the same conceptual well but utilize the concepts to suit their own purposes. In other words, regardless of the ambiguity surrounding the relationship of Revelation to the apocalyptic tradition, it appears that the hearers of Revelation would move easily in this apocalyptic conceptual world."), _c('a', {
    attrs: {
      "id": "fn24"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('i', [_vm._v("Revelation as Intertext")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("If there are questions about the extent of the relationship of Revelation to the apocalyptic tradition, there are no such questions with regard to its relationship to the OT. Revelation is overflowing with OT imagery, ideas, and vocabulary. Yet, unlike in many NT documents, by most reckonings there is not a single direct quotation of the OT in this book. A reading of Revelation reveals that its utilization of the OT is not primarily concerned with respecting the OT context of a given idea, thought, or term.")]), _c('a', {
    attrs: {
      "id": "fn25"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25"
    }
  }, [_vm._v("25")])]), _vm._v(" At the same time, the hearer of Revelation soon discovers that the OT is more than a language arsenal from which the writer constructs his own theological statement or prophetic vision."), _c('a', {
    attrs: {
      "id": "fn26"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Rather, the relationship between Revelation and the OT is a much more dynamic phenomenon. Revelation is better seen as an intertext where a variety of texts (including those of the writer, John!) converge and/or intersect. The intersection of OT texts, ideas, imagery, and vocabulary with John’s visionary experience results in an intertext where echoes and allusions to the OT (among other things) provide shape and definition of meaning to the vision that is Revelation. Sometimes these allusions are like loud voices calling out to the hearers, while at other times they are no more than mere whispers to which the hearers’ ears must be attuned or they will be missed altogether. Such a dynamic understanding of the relationship between Revelation and the OT means that no mere listing of allusions or echoes to the OT does justice to this dimension of Revelation. For everything found in Revelation is influenced, in one way or another, by the OT."), _c('a', {
    attrs: {
      "id": "fn27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27"
    }
  }, [_vm._v("27")])]), _vm._v(" Specifically, one must ask how the OT context interacts with the NT context."), _c('a', {
    attrs: {
      "id": "fn28"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28"
    }
  }, [_vm._v("28")])]), _vm._v(" Discernment of these echoes and allusions is called for here, perhaps in ways not unlike the discernment called for in the receiving and recording of this prophecy by John and the task of the circle of prophets mentioned earlier. However, it is safe to say that any hearers or readers of Revelation who neglect the voice of the OT do so at their own peril.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('i', [_vm._v("The Canonical Location and Function of Revelation")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Whatever the historical events that resulted in the current New Testament canon, it is clear that the interpretive role and influence of a given book have significance within the structure of the overall canon. In this section we consider certain observations about the role and function of Revelation in the New Testament canon.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("First, though, we should note that not all groups of Christians include Revelation as part of their canon.")]), _c('a', {
    attrs: {
      "id": "fn29"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29"
    }
  }, [_vm._v("29")])]), _vm._v(" It should also be observed that, while Revelation stands last in the vast preponderance of canonical lists, the book follows the Gospels in a few listings."), _c('a', {
    attrs: {
      "id": "fn30"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30"
    }
  }, [_vm._v("30")])]), _vm._v(" Two reasons may account for such a location. First, since Revelation contains so many words of the resurrected Jesus, we can understand how it made some sense to locate the book after the documents that give careful attention to his “pre-ascension” words."), _c('a', {
    attrs: {
      "id": "fn31"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31"
    }
  }, [_vm._v("31")])]), _vm._v(" At the same time, the close affinity that exists between the Fourth Gospel and Revelation may also account for the latter being drawn to a position in closer canonical proximity to the former."), _c('a', {
    attrs: {
      "id": "fn32"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Owing to its unique standing as the last book in the biblical canon, Revelation functions on several canonical levels. The best way to approach this topic is perhaps to structure these canonical reflections in a way that moves from Revelation’s function in connection with the books in closest canonical proximity to its broader function in the metanarrative of the whole Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Revelation is quite obviously connected canonically to the Epistles, the documents that precede it in the NT; as noted earlier, it too takes the form of an epistle. In this regard, Revelation furthers a number of concerns and themes found among both the letters of Paul and those that come from other voices. Of the specific concerns addressed, Revelation continues the theme of false teaching that is more than of passing interest in a large number of the epistles. Among other things, Revelation makes clear both that false teaching is dangerous to the Christian community and that anyone who identifies with it will share in the destruction that awaits the evil triumvirate of Satan, the beast, "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("and the false prophet. Revelation also continues the emphasis of several of the epistles on the return of Jesus.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The canonical function of Revelation may also be seen in its connections to the Johannine literature that precedes in the NT. First, one of the great points of both continuity and development is the presentation of Jesus. On the one hand, the image of Jesus as the (paschal) Lamb of God found in the Fourth Gospel (1:29) also appears in Revelation (5:6). On the other hand, the revelation of Jesus in Revelation includes a development of this image to such an extent that it is not uncommon for students of Scripture to speak of the Wrath of the Lamb as a way of describing the Lamb’s identity in this book.")]), _c('a', {
    attrs: {
      "id": "fn33"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33"
    }
  }, [_vm._v("33")])]), _vm._v(" Second, the pneumatology of the Fourth Gospel, which places a great deal of emphasis upon the role of the coming Paraclete,"), _c('a', {
    attrs: {
      "id": "fn34"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34"
    }
  }, [_vm._v("34")])]), _vm._v(" and that of 1 John, where the Spirit’s role in prophetic activity comes into focus,"), _c('a', {
    attrs: {
      "id": "fn35"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35"
    }
  }, [_vm._v("35")])]), _vm._v(" gives way to a more full-blown prophetic pneumatology in Revelation."), _c('a', {
    attrs: {
      "id": "fn36"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The canonical function of Revelation also extends to its relationship with the Gospels, located at the other end of the NT. The major sections devoted to the return of Jesus in Matthew (24–25), Mark (13), and Luke (21) in some ways serve to anticipate the more extended discussion of this topic in Revelation. Here too, the full implications of the Messiah’s coming for both the Jewish people and the nations, announced in Matt 1, are made explicit in the imagery of Revelation (cf. especially the relationship between the 144,000 and the innumerable multitude in ch. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition, the canonical function of Revelation can also be seen at the metanarrative level of the Bible. First, the book serves as a fitting conclusion to the story of humanity’s rebellion against God. This story, which began so long ago in Genesis, is completed by a vision of God’s reign and rule established completely. Second, in Revelation a number of God’s purposes for his creation are redeemed, especially through the thousand-year reign. Third, in many ways Revelation functions as the fulfillment and completion of all biblical prophecy that came before it. Finally, through this book it becomes apparent that many of the judgments of God, which were longed for so long by his people, will not ultimately take place until the end of time."), _c('a', {
    attrs: {
      "id": "fn37"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle2",
    attrs: {
      "id": "in08"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Audience")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("What might be known of the audience to whom these words of prophecy were written? Unlike a number of other NT letters (both circular and specific), the text of Revelation gives some specific information as to the identity of its intended audience. This information includes the names of the cities in Asia Minor where the churches are located to whom the seven prophetic messages are addressed in chapters 2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in09"
    }
  }, [_c('i', [_vm._v("Geographic Location — Asia Minor")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The interpreter of Revelation has good reason to believe that the prophecy’s intended audience includes churches in the cities of Ephesus, Smyrna, Pergamum, Thyatira, Sardis, Philadelphia, and Laodicea. This geographic location is confirmed by John’s writing from the island of Patmos, which is just off the coast of Asia Minor in the Aegean Sea.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("This listing of these specific cities informs the interpreter of Revelation in several ways. When these seven cities are located on a map of Asia Minor, one discovers that, in their textual order, they are not haphazardly arranged but take on a certain shape. One who follows the textual order of these cities on a map of Asia Minor would begin with Ephesus in the south, go due north to Smyrna, and then on due north to Pergamum. From Pergamum, the northernmost city in the list, one would go southeast to Thyatira, due south to Sardis, southeast to Philadelphia, and then southeast again to Laodicea. While there may be literary and theological reasons for this particular order, an issue to be taken up later, it is often noted that the textual order of these cities is owing to their location on an ancient trade and postal route.")]), _c('a', {
    attrs: {
      "id": "fn38"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38"
    }
  }, [_vm._v("38")])]), _vm._v(" (See map on page 18.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This list of churches found in Revelation is informative in other ways as well. On the one hand, an examination of this list reveals that several of these cities are also known from other early Christian writings. Paul writes a (circular) letter to the church at Ephesus and indicates that he has written the church at Laodicea, instructing the church at Colossae to exchange letters with this congregation (Col 4:16). Ignatius is known to have written letters to the churches at Ephesus, Smyrna, and Philadelphia. Polycarp served as the bishop of Smyrna, while Melito functioned in that capacity at Sardis. On the other hand, other churches in Asia Minor were located in cities not mentioned in Revelation. Paul refers to the church in Hierapolis (Col. 4:13), where Papias later served as bishop, and Ignatius wrote letters to the churches in Tralles and Magnesia."), _c('a', {
    attrs: {
      "id": "fn39"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "imageC1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "P18",
      "src": "images/P18.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("John makes no mention of certain prominent churches and cities (Colossae, Hierapolis), while including others that seem to be less prominent within early Christian circles (Thyatira), which suggests that the seven churches listed in Revelation should not be taken to imply that he knows of these seven and no more. Rather, such selectivity suggests that these seven churches serve as representatives of other (unnamed) churches. Since seven is a sign of completion in Revelation, it appears that these seven churches represent all (Johannine) churches. Consequently, the mention of these seven churches suggests that Revelation is intended to be heard by all the churches of Asia Minor.")])]), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('i', [_vm._v("The Johannine Community")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Not only do the seven cities listed in Revelation reveal something about the book’s intended audience, but the identity of the audience is also brought into sharper focus by inquiring as to the relationship of Revelation to other Johannine documents found in the NT. Specifically, the question may be asked, How is Revelation connected to what most scholars describe as the Johannine community?")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Few NT works are more similar in expression than 1 John and the Fourth Gospel.")]), _c('a', {
    attrs: {
      "id": "fn40"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40"
    }
  }, [_vm._v("40")])]), _vm._v(" It thus appears likely from the close literary and theological affinities between the Fourth Gospel and the Johannine Epistles that these documents come from the same community or circle, if not the same hand. In the case of the Fourth Gospel, the Beloved Disciple is identified as the one who wrote these things, though it is clear from the third person language used that other hands were involved. In the case of 2 and 3 John, the author explicitly identifies himself as “the Elder,” clearly an (if not "), _c('i', [_vm._v("the")]), _vm._v(") authoritative leader in the community. It is likely that 1 John is also the result of the Elder’s literary activity."), _c('a', {
    attrs: {
      "id": "fn41"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41"
    }
  }, [_vm._v("41")])]), _vm._v(" To speak of the Johannine community, then, is to speak of the individuals and congregations over which the Beloved Disciple and/or the Elder offered spiritual oversight."), _c('a', {
    attrs: {
      "id": "fn42"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three pieces of evidence suggest that Revelation and its audience(es) are part of this Johannine community. First, a careful comparison of the language of Revelation with that of the Fourth Gospel reveals that, although a number of linguistic differences exist between the two documents, they exhibit so many kinds of similarities that it is more than safe to assume these documents come from the same family or community."), _c('a', {
    attrs: {
      "id": "fn43"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43"
    }
  }, [_vm._v("43")])]), _vm._v(" Second, there are a number of points at which one can detect certain theological affinities between Revelation and the Johannine literature."), _c('a', {
    attrs: {
      "id": "fn44"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44"
    }
  }, [_vm._v("44")])]), _vm._v(" As noted earlier, both the Fourth Gospel "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("and Revelation regard Jesus as the (paschal) Lamb of God. Though differently nuanced, the issue of witness or testimony is another point of theological affinity, as it is prominent in the Fourth Gospel, as well as Revelation.")]), _c('a', {
    attrs: {
      "id": "fn45"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45"
    }
  }, [_vm._v("45")])]), _vm._v(" There are also certain similarities of thought in these major Johannine documents reflected in the understanding of the unity and diversity of God. Third, an obvious indicator that Revelation is part of the Johannine community is the fact that all of these documents are either directly or indirectly tied to the name John, though Revelation is the only document in which the name appears in the text itself."), _c('a', {
    attrs: {
      "id": "fn46"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in11"
    }
  }, [_c('i', [_vm._v("OT Literature (Intertextuality)")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The intertextual nature of the document also reveals something about the audience implied by Revelation. The frequency with which OT imagery and allusions appear within the book suggests that the hearers and readers are not only well versed in the OT (being expected at times to pick up on some very faint allusions) but that the Jewish Scriptures were revered as authoritative within the community. Such familiarity and respect suggest that the heritage of Israel is regarded in some sense as the heritage of the community as well.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in12"
    }
  }, [_c('i', [_vm._v("People of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("In addition to being people of the OT, the text suggests that the readers are people of the Spirit as well. This aspect of the hearers’ identity is supported by two pieces of textual evidence. It is clear that the hearers implied by the text have some understanding of the Spirit’s activity. Such an understanding includes both the affinity the hearers appear to have with John’s experiences of being “in the Spirit” at various points and the ability to discern pneumatic speech (2:7, 11, 17, 29; 3:6, 13, 22)"), _c('a', {
    attrs: {
      "id": "fn47"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47"
    }
  }, [_vm._v("47")])]), _vm._v(" and to enter into “pneumatic ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πνευµατικῶς")]), _vm._v(", "), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("pneumatikōs")])]), _vm._v("] interpretation” (11:8). Not unrelated to this awareness of the Spirit’s activity is the prophetic activity that permeates the document. Not only is the audience aware of prophetic figures in its midst, but there are also indications "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("that the hearers themselves are viewed as participants in such prophetic activity. Whether or not the text implies a belief in the “prophethood of all believers,” it does suggest a deep level of participation within the community of a variety of (if not all) individuals.")]), _c('a', {
    attrs: {
      "id": "fn48"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in13"
    }
  }, [_c('i', [_vm._v("Women")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Another dimension of the audience’s identity appears to be revealed by the significant role that women play in Revelation. The first of four references to women in this book occurs early on, in 2:20, where reference is made to a woman named Jezebel, who speaks of herself as a prophetess but who actually teaches and deceives “my servants” to commit sexual immorality and eat food sacrificed to idols. That she represents a real person within the community is suggested by her being given an opportunity to repent, though she refuses to do so. This interpretation is confirmed by the judgment that awaits her and her children. Despite the symbolic nature of her name (what the resurrected Jesus calls her, “Jezebel,” as opposed to what she calls herself, “prophetess”), her existence reveals that the prophetic figures in this prophetic community include women. For she is condemned, owing not to her gender, but to her deception. The next reference to a female occurs in Rev 12, where we find reference to a woman clothed with the sun. While her identity is debated, her strategic location in salvation history is clear. Somewhat like psychedelic imagery, this woman changes forms as she conveys characteristics of a variety of female figures to include Eve, Israel, Mary, and the church. The third female image to appear in Revelation is found in Rev 17–18, Babylon the great whore. This image gives way in Rev 19 and following to the bride of Christ, New Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Such depictions indicate that women are included within the audience implied by this text, confirming the picture of the role of women within the Johannine community that emerges from an examination of the Fourth Gospel, where every female character serves as an exemplary model of belief. Though Revelation includes negative images of women, they are never denigrated because of their gender but are assessed on the basis of their behavior and relationship to God."), _c('a', {
    attrs: {
      "id": "fn49"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('i', [_vm._v("Witness and Persecution")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The prominence of the theme of witness or testimony against the backdrop of a hostile environment implies that at least certain parts of the intended audience of Revelation are familiar with the necessity of bearing witness in the face of opposition and the distinct possibility that such activity could lead to various forms of persecution, including death. While it might be going too far to say that the entire community experienced persecution, and while the external evidence for the extent of such persecution is very much debated, the text makes clear that the audience is familiar with persecution owing to their witness. One of the primary pieces of evidence for this conclusion is the way in which the prominent witnesses within Revelation all experience death. This theme begins in 1:5 with the description of Jesus Christ, who is called "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ µάρτυς ὁ πιστός")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("ho martys ho pistos,")])]), _vm._v(" “the faithful witness”). The fact that being a “faithful witness” involves death is made clear in the next phrase, which describes him as “the firstborn of the dead.” That such “faithful witness” is not confined to the work of Jesus but extends to his followers as well is confirmed in 2:13 by mention of Antipas, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ µάρτυς µου ὁ πιστός µου")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("ho martys mou ho pistos mou,")])]), _vm._v(" “my faithful witness”). In order that the point not be missed, the relationship between “faithful witness” and death is again underscored in the text, where the reference to Antipas is followed by the words “who was put to death among you.” Lest it be thought that Antipas’s “faithful witness” was a one-off event, Rev 11:1-13 speaks of two witnesses who are protected by God until their witness is completed, at which point the beast overcomes and kills them (v. 7). They, like their Lord, are vindicated by being raised from the dead and taken up to heaven while their enemies look on (vv. 11-13). This theme of the cost of faithful witness may also be found in the poetic words about believers found in 14:4, where it is said, “These follow the Lamb wherever he leads.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("In addition to the connection between faithful witness and death is John’s own appearance on Patmos, which was because of “the word of God and the testimony of Jesus.” Several times in the seven prophetic messages of chapters 2–3, there are indications that the hearers have experienced or will experience opposition owing to their belief. This includes hardships (2:3), afflictions, slander, imprisonment (2:8-10), death (2:13), and little strength (3:8). To this evidence might be joined the admonitions to “overcome” found at the end of each prophetic message (2:7, 11, 17, 26-28; 3:5, 12, 21), the words of encouragement to the hearers found at various points throughout the book (13:9; 14:13; 16:15), and the frequent reference to those who have given their lives, shed their blood, or were “warred against” for the sake of the Lamb (6:9-11; 7:14-17; 12:17; 14:12; 16:6; 17:6; 18:24; 19:2; 20:4-6). While questions remain about the extent of the ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("community’s acquaintance with persecution, the audience envisioned by the text appears to understand that their identification with the testimony of Jesus could and perhaps would lead to persecution.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in15"
    }
  }, [_c('i', [_vm._v("Opponents and Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("If the text of Revelation suggests that persecution and suffering are part of the audience’s horizon, what does it reveal about the source of this opposition? This question must be answered in two parts, for the text envisions the antagonists in cosmic terms that take concrete expression in the world of the audience.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle4",
    attrs: {
      "id": "in16"
    }
  }, [_c('i', [_vm._v("Cosmic Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("On the cosmic level, the opposition faced by the community is primarily the evil triumvirate of Satan, the beast, and the false prophet (the other beast). At many points this evil trinity parodies what is said of the one who sits on the throne, the Lamb, and the seven Spirits of God. The ultimate figure standing behind the opposition to the believers is Satan. In two texts (12:9; 20:2) he is identified more fully as the great dragon, the ancient serpent, the devil. He orchestrates religious opposition by means of “the synagogue of Satan” in Smyrna (2:9) and Philadelphia (3:9). Not only is he able to cause the church to suffer by having some of them imprisoned (2:10), but also, in a parody of God, he has a throne, and where he lives is where “my faithful witness” Antipas died (2:13). Apparently, his “deep secrets” are the source of false teaching (2:24). Satan is the one who opposes and seeks to destroy the woman clothed with the sun, her male child, and the rest of her seed (12:1-13). However, he loses his place in heaven at the hands of Michael (12:7-12), an event that fills him with fury to oppose more completely the church (12:12). As a result, the dragon gives his power and throne and great authority to the beast (13:2), which results in worship of the dragon and the beast (13:4). The relationship between the dragon and the other beast is indicated by the latter’s speaking like a dragon (13:11). The unity of the dragon, the beast, and the false prophet is underscored by demon spirits coming from each of their mouths performing miraculous signs (16:13). Satan’s work is that of deceiving the nations (20:3, 7-8). However, he is thrown into the Abyss for a thousand years (20:2) and ultimately into the lake of fire (20:7-10).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Satan is joined in opposing God and his people by the beast, whose very first mention is in connection with killing the two witnesses who prophesy in 11:7. There the beast comes up from the Abyss, but in 13:1 he comes up out of the ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("sea. Receiving his power from the dragon, he parodies the Lamb by having a fatal head wound that is healed (13:3) and, like the dragon, is worshipped (13:4), a practice facilitated by the other beast (13:11-17). The number of the beast is 666 (13:18), but those who receive his mark will be punished by God (14:9-11; 16:2), as will the beast himself (16:10). By way of contrast, the beast, his image, and his number are overcome by those standing beside the sea of glass (15:2). The relationship of the beast to Babylon the Great, the mother of whores, is made clear in chapter 17, where the woman is found riding the back of the beast (vv. 3, 7). The astonishment he causes is because, in a parody of God, he is described with the words “he was, he is, and he comes” (vv. 8, 11). His close relationship with the ten kings who have not yet received a kingdom is also underscored (vv. 11-14, 16-17). However, the beast’s opposition to the Lamb is futile, as he is thrown into the lake of fire (19:20), sharing Satan’s fate (20:10), while those put to death by him “live and reign” (20:4).")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The third member of the evil triumvirate, the “other beast,” comes up out of the earth. Looking like a lamb and sounding like a dragon, his authority comes from the first beast, which he uses to cause all the earth’s inhabitants to worship the first beast, going so far as to set up an image of the beast, which he causes to speak (13:11-15). He performs great signs, causing fire to fall from heaven, deceiving the inhabitants of the earth (v. 14). His efforts result in a complete control of economic activity, so that anyone wishing to buy or sell must have the mark of the beast in one’s hand or on one’s forehead (vv. 16-17). Along with the dragon and the beast, demon spirits come from the mouth of “the false prophet” (16:13), and he shares their fate in the lake of fire (19:20; 20:10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Joining the evil triumvirate as the other major cosmic opponent in Revelation is Babylon the Great, who is identified as "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἡ µήτηρ τῶν πορνῶν")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("hē mētēr tōn pornōn,")])]), _vm._v(" “the mother of sexual immorality”). She sits upon many waters (peoples, multitudes, nations, and languages). Elaborately dressed (17:4), she is drunk on the blood of the saints (v. 6), committing sexual immorality with the nations and kings of the earth (18:3), though she is eventually betrayed by her “partners” (17:16-17). She is the great city that rules over the kings of the earth. Her destruction and the mourning it causes are described in some detail in chapter 18.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle4",
    attrs: {
      "id": "in17"
    }
  }, [_c('i', [_vm._v("Concrete Expressions of Opposition")])])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The opposition faced by the audience also takes concrete expression in the text of Revelation. While all opposition is understood to have a cosmic explanation, at numerous points it is possible to discern certain concrete expressions of the ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("opposition faced by the church. These primarily take three forms. First, at any number of places it appears that the image of Rome is discernible. Perhaps the most likely example of such a reference comes in chapter 17, where the seven heads of the beast upon which the woman, Babylon the Great, sits are seven hills. The reference to the seven hills of Rome may well be present. The mention that these seven hills are seven kings may also be a possible allusion to Roman rulers, especially with the mysterious words that “five have fallen, one is, and the other is yet to come” (17:10). The relationship between the beast and Nero, who both suffer fatal head wounds, may also direct the readers’ attention to Rome and its opposition to the church.")]), _c('a', {
    attrs: {
      "id": "fn50"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50"
    }
  }, [_vm._v("50")])]), _vm._v(" Finally, there also appears to be a rather direct, scathing economic critique of Rome and its power in chapter 18."), _c('a', {
    attrs: {
      "id": "fn51"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are also hints that the audience of Revelation faced concrete opposition in the form of its relationship with the Jewish community. As already noted, the audience of Revelation appears to have a clear appreciation for its Jewish heritage. Not only does its presumed familiarity with the OT point in this direction, but also the way in which certain “Christian” details are grounded in Jewish roots. At the same time, there is clear tension reflected in the book with the broader Jewish community. The pejorative description “the synagogue of Satan,” found twice (2:9; 3:9), carries with it the accusation that there were those who claimed to be Jews but were not. The church at Smyrna is slandered by this “Jewish” community (2:9). This group may even have been regarded as having the power to cause the imprisonment of members of the church (v. 10). The opposition offered the church at Philadelphia by this “Jewish” community is such that the risen Christ speaks words of vindication (3:9). While it might be going too far to argue that the audience of Revelation as a whole is in a struggle with the Jewish community, it seems reasonable to suggest that it is in some conflict with the broader Jewish community, revolving around the issue of identity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A final concrete expression of opposition to the audience is perhaps the clearest of the three, namely, the threat of false teaching, false prophets/prophetesses, false apostles, and immoral behavior. In point of fact, it appears from the seven prophetic messages in Rev 2–3 that the churches are beset by these problems more than by any other opposition. The church at Ephesus is praised for not tolerating evil individuals, testing those who claimed to be apostles but were not (2:2), and hating the works of the Nicolaitans (2:6). Conversely, the church at Pergamum is rebuked for having some in its midst who keep the teaching of Balak (idolatry and sexual immorality) and the teaching of the Nicolaitans (2:14-15). The church at Thyatira struggles with the woman who "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("calls herself a prophetess but whom the risen Jesus calls Jezebel (2:20-25). Her works include sexual immorality and eating food sacrificed to idols. Those who commit sexual immorality with her will be punished with her. The theme of false teaching and false prophecy continues as Revelation describes the activities of the dragon, the beast, the false prophet, and the great whore. The temptation of the church to capitulate to these activities is conveyed in part by John’s astonishment at the appearance of Babylon the Great (17:6). When the inhabitants of the world saw the healing of the beast’s wounded head, they were astonished and in turn worshipped the beast (13:3-4). When John saw the great whore, he was astonished and was immediately rebuked by the angel, who asked, “Why are you astonished at her?” and then explained the mystery of the woman (17:6-7). Clearly, such opponents were an ongoing part of the reality faced by the audience of Revelation.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "CHTitle2",
    attrs: {
      "id": "in18"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The date of Revelation is a notoriously difficult issue to sort out, for the evidence may be read in at least three different ways. The dominant view for the better part of eighteen centuries was that the document was written sometime during the reign of Domitian (81-96 CE). In the last century a fair number of scholars held that the book emerged earlier, at the time of the emperor Nero (sometime between 64 and 70 CE). A still more recent proposal has sought to combine the evidence for both of these views, arguing that the vision was experienced sometime during the time of Nero but was written down much later, during the time of Domitian. What accounts for such wide divergence of dates among interpreters? Part of the answer to this question is the uncertainty that accompanies almost every piece of relevant evidence. One soon discovers that the interpretive challenges one faces, as with so many other aspects of Revelation, are no less great here.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in19"
    }
  }, [_c('i', [_vm._v("Internal Indicators")])])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Given its similarities at a number of points to the OT prophetic literature, it is somewhat surprising to find that in Revelation there is an absence of any internal dates, unlike some of the prophetic literature. This is all the more surprising in the light of John’s naming himself as the author rather than using a pseudonym, an unusual if not unique phenomenon among apocalyptic documents. Yet despite this lack of internal references to date, several texts within ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Revelation could provide textual clues that may reveal something about the date of the document. While more extensive exploration of the verses in question must await discussion in the commentary proper, we briefly survey each clue here. Some of the more prominent include:")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("the mention of seven kings in Rev 17:9-11,")]), _vm._v(" "), _c('li', [_vm._v("the present tense reference to the temple in Jerusalem in 11:1,")]), _vm._v(" "), _c('li', [_vm._v("the use of the term Babylon to refer to Rome,")]), _vm._v(" "), _c('li', [_vm._v("the relationship between the beast with the wounded head and the legend that Nero would return,")]), _vm._v(" "), _c('li', [_vm._v("the use of the language “the twelve apostles” in 21:14,")]), _vm._v(" "), _c('li', [_vm._v("the identity of the persecutor of the church,")]), _vm._v(" "), _c('li', [_vm._v("the relationship of the worship of the beast and emperor worship in chapter 13, and")]), _vm._v(" "), _c('li', [_vm._v("the Sitz im Leben of the seven churches in chapters 2–3.")])])]), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("On the face of it, one of the clearest internal indicators with regard to date is the mention of seven kings in Rev 17:9-11. Of the seven kings, who are the seven hills upon which the great whore sits, “five have fallen, one now is, the other is not yet,” and when this one comes, it is necessary for him to remain a little while. The beast who was and is not, is an eighth king, being one of the seven. Since this list may be thought to refer to Roman leaders (i.e., the seven hills), it might seem a simple matter to count down the list of Roman emperors until one arrives at the sixth one — and now we have discovered the date of composition. A number of complications, however, face the interpreter, as the chart")]), _c('a', {
    attrs: {
      "id": "fn52"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52"
    }
  }, [_vm._v("52")])]), _vm._v(" on page 28 reveals:")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chart lists all the Roman emperors from Julius Caesar to Trajan, while the letters across the top of the chart represent different ways in which the emperors may be numbered. Does one begin with Julius Caesar (as in A, B, and H) or Augustus (as in C and D) or Gaius (as in E) or Nero (as in F) or Galba (as in G)? Are the three so-called minor emperors included (as in A, C, E, F, and G) or excluded (as in B, D, and H)? Does one count only those emperors deified by the Roman Senate or who claimed divinity for himself (as in H)? From an examination of the list, it is apparent that a variety of attempts can be made to determine which figure is to be identified as the sixth king, with little scholarly consensus. Suffice it to say that the reference to the seven kings in Rev 17 is not sufficient by itself to determine the date of the book’s composition. Rather, one might observe that, if one can determine the date of the book on other terms, the list of kings can be manipulated to fit it.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('b', [_vm._v("Roman Emperor")])])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("A")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("B")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("C")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("D")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("E")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("F")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("G")])]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_c('b', [_vm._v("H")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Julius Caesar (101-44 BCE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Augustus (27 BCE–14 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Tiberius (14-37 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Gaius (37-41 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Claudius (41-54 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Nero (54-68 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Galba (June 68-Jan 69 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Otho (Jan-Apr 69 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Vitellius (Apr-Dec 69 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Vespasian (Dec 69-June 79 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Titus (79-81 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Domitian (81-96 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7(8)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("6")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("[Neronic antichrist]")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7(8)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Nerva (96-98 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }, [_vm._v("7(8)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("Trajan (98-117 CE)")]), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-center"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Mention of the temple in Rev 11 might also be thought to help establish the date of Revelation. The present tense reference to the temple could suggest that it was still standing in Jerusalem at the time of the book’s composition, thus, arguing for a date of composition before 70 CE. This literal reading of the text, however, does not square with the details, for the dimensions of the temple described in chapter 11 reveal that this temple is not the Herodian structure but appears to resemble the one described in Ezek 40–48."), _c('a', {
    attrs: {
      "id": "fn53"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53"
    }
  }, [_vm._v("53")])]), _vm._v(" Neither is it altogether clear that the temple described in Rev 11 is actually located in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The use of the term Babylon to refer to Rome might also have some bearing on the topic of date, since it appears that such references to Rome do not appear in apocalyptic documents until after 70 CE. Part of this suggestion seems to be based upon the parallel of Babylon destroying Jerusalem in 586 BCE and now, a second time, Babylon (Rome) destroying Jerusalem."), _c('a', {
    attrs: {
      "id": "fn54"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54"
    }
  }, [_vm._v("54")])]), _vm._v(" While such evidence would seem to indicate that the book was written after 70, a reference to “Babylon,” apparently with reference to Rome, is found in 1 Pet 5:13, a book widely thought to have been written in the 60s.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Another tantalizing reference in the text with regard to establishing the date of the book is the reference to the beast with the wounded head that has been healed (13:3, 12). On one level, the reference is a clear parody of the Lamb who looked as if he had been slain in chapter 5, but on another level numerous interpreters have seen a not-so-subtle reference to a legend that emerged sometime after Nero’s death that he would come back to life. Obviously, this myth could not have occurred before Nero’s death in 68 CE. It appears, however, that this rumor did not circulate widely until near the end of the first century, when various impostors turned up claiming to be Nero!")]), _c('a', {
    attrs: {
      "id": "fn55"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is also possible that the phrase “the twelve apostles” occurring in the description of New Jerusalem in 21:14 reveals something about the date of Revelation. Here several points should be made. While reference to “the Twelve” does appear on occasion in the Fourth Gospel (6:67, 70-71; 20:24), in the Johannine literature there are no occurrences of the term "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπόστολος")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("apostolos,")])]), _vm._v(" “apostle”), except for its proverbial use in John 13:16, outside of Revelation, where it occurs three times: in Rev 2:2, referring to those who claimed to be apostles but were not, and in 18:20 and 21:14. At the same time, while the term “apostle” occurs frequently in other strands of NT thought, the term “the twelve apostles” is relatively rare, occurring only in Matt 10:2 and the textually uncertain Luke 9:1 and 22:14. The term is also found in the title of the "), _c('i', [_vm._v("Didache.")]), _c('a', {
    attrs: {
      "id": "fn56"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56"
    }
  }, [_vm._v("56")])]), _vm._v(" Taken together, this evidence appears to indicate that the designation appears for the first time in the last quarter of the first century CE, perhaps implying a later date for Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As noted earlier, the audience envisioned by the text of Revelation is one familiar with persecution. If the specific persecution that lies behind the text were identifiable, it would be possible to be more certain about the date of the document. Before looking at specific examples of persecution, it should be remembered that the extent of the persecution envisioned by the text is not altogether clear. While in the seven prophetic messages some persecution has been experienced and more is anticipated, for the most part, the suffering of the Christians comes from the hands of the “Jewish community” rather than the Romans."), _c('a', {
    attrs: {
      "id": "fn57"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57"
    }
  }, [_vm._v("57")])]), _vm._v(" However, if Roman persecution is part of the landscape, as the book may suggest, then two primary options present themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is well known that Nero initiated a severe persecution of Christians. According to Tacitus ("), _c('i', [_vm._v("Annals")]), _vm._v(" 15.44), in order to divert the blame from himself for the fire that devastated Rome, Nero blamed and persecuted the Christians:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Therefore, to scotch the rumour, Nero substituted as culprits, and punished with the utmost refinements of cruelty, a class of men, loathed for their vices, whom the crowd styled Christians. Christus, the founder of the name, had undergone the death penalty in the reign of Tiberius, by sentence of the procurator Pontius Pilatus, and the pernicious superstition was checked for a moment, only to break out once more, not merely in Judea, the home of the disease, but in the capital itself, where all things horrible or shameful in the world collect and find a vogue. First, then, the confessed members of the sect were arrested; next, on their disclosures, vast numbers were convicted, not so much on account of arson as for hatred of the human race. And derision accompanied their end: they were covered with wild beasts’ skins and torn to death by dogs; or they were fastened on crosses, and when daylight failed were burned to serve as lamps by night. Nero had offered his Gardens for the spectacle, and gave an exhibition in his Circus, mixing with the crowd in the habit of a charioteer, or mounted on his car. Hence, in spite of a guilt which had earned the most exemplary punishment, there arose a sentiment of pity, due to the impression that they were being sacrificed not for the welfare of the state but to the ferocity of a single man.")]), _c('a', {
    attrs: {
      "id": "fn58"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Suetonius ("), _c('i', [_vm._v("Nero")]), _vm._v(" 16.2) simply observes, “Punishment was inflicted on the Christians, a class of men given to a new and mischievous superstition.”"), _c('a', {
    attrs: {
      "id": "fn59"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Clearly these texts indicate that a persecution of Christians did take place under Nero, a figure who could be called or likened to a beast in non-Christian documents"), _c('a', {
    attrs: {
      "id": "fn60"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60"
    }
  }, [_vm._v("60")])]), _vm._v(" and about whom a legend arose of his return after his death. This sort of evidence makes an early date appealing. However, evidence for a persecution that extends to Asia (Minor), leading to exile, is still not forthcoming for this period. Consequently, while appealing, such evidence does not prove conclusive with regard to the date of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also some evidence of a persecution of Christians under Domitian. In addition to the uncomplimentary picture of Domitian that emerges from the Roman historians Tacitus and Suetonius, there are a few other pieces of relevant information. Melito of Sardis (quoted in Eusebius, "), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 4.26.9-10) reminds his reader, Marcus Aurelius, that Christians got on quite well with Rome for the most part, with two ominous exceptions: “The only emperors who were ever persuaded by malicious men to slander our teaching "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("were Nero and Domitian, and from them arose the lie, and the unreasonable custom of falsely accusing Christians. But their ignorance was corrected by your pious fathers, who wrote many rebukes to many, whenever they dared take new measures against Christians.”")]), _c('a', {
    attrs: {
      "id": "fn61"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Tertullian ("), _c('i', [_vm._v("Apology")]), _vm._v(" 5.4) specifically states that Domitian was involved in the persecution of Christians but that he eventually relented: “Domitian, too, a man of Nero’s type in cruelty, tried his hand at persecution; but as he had something of the human in him, he soon put an end to what he had begun, even restoring again those whom he had banished.”"), _c('a', {
    attrs: {
      "id": "fn62"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The closest one comes geographically to evidence of a persecution of Christians in Asia (Minor) is found in the written correspondence between Pliny, Trajan’s legate in Bithynia, and the emperor (Pliny’s "), _c('i', [_vm._v("Letters,")]), _vm._v(" 10.46-47). These letters reveal several things about the nature of the persecution. It is clear from the correspondence that Pliny is not at all certain about how to proceed with his interrogations and decisions, indicating that there was no formal policy on the matter, a fact that Trajan confirms in response. It is also obvious that a number of Christians had been put to death as a result of the investigations. Not only were suspects interrogated, but some were also tortured in order for Pliny to get to the truth of the matter. Pliny indicates that formal worship of Trajan’s statue and the images of the gods, along with cursing Christ, was treated as sufficient evidence that such ones were no longer considered Christian, a strategy with which Trajan agrees. This evidence, which may be dated somewhere around 111 CE, is almost fifteen years removed from the reign of Domitian. Unlike the evidence regarding Nero and Domitian, however, this evidence of persecution is not far removed geographically from the churches mentioned in Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It may be tentatively concluded that, while the evidence for persecution at various periods might be of some assistance in constructing general attitudes with regard to the persecution of Christians in this general time frame, it does not in and of itself settle the issue of the date of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The emphasis upon worship of the dragon and beast, combined with the implicit identification of the beast with Rome, might be taken as evidence that, at the time of the book’s composition, the community was faced with enforced emperor worship. Part of the problem in using this topic to gain leverage on the issue of date is that solid evidence for such a practice is very late. In point of "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("fact, Pliny offers the earliest unequivocal testimony of such a practice, and even it does not seem yet to be a formal practice. This is not to suggest that such temptation was not part of the audience’s horizon, but again to note that such a possibility does not settle the issue of date.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Finally, it is possible that the condition of the seven churches described in chapters 2–3 could provide clues as to the date of the document’s composition.")]), _c('a', {
    attrs: {
      "id": "fn63"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63"
    }
  }, [_vm._v("63")])]), _vm._v(" Such an investigation is notoriously dangerous and fraught with the challenges of getting the interpretive “cart before the horse,” creating a life setting to read the text over against. While it is possible that these descriptions can bring clarity to a variety of issues once a date has been established, such an approach cannot speak definitively to the issue.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ambiguity of much of the internal evidence thus makes a decision with regard to date difficult if not impossible. There are so many uncertainties and the attempt to reconstruct the original life setting so hypothetical that certainty on the matter is perhaps beyond the reach of the interpreter. On balance, however, the internal evidence tends to favor a later date of composition, if only slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in20"
    }
  }, [_c('i', [_vm._v("External Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The external evidence is hardly more helpful than the ambiguity of the internal textual indicators with regard to date. What may be said with certainty is that Revelation was known to exist by 135 CE, based on the words of Justin Martyr in "), _c('i', [_vm._v("Dialogue with Trypho")]), _vm._v(" (81.4):")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("And further, there was a certain man with us, whose name was John, one of the apostles of Christ, who prophesied, by a revelation that was made to him, that those who believed in our Christ would dwell one thousand years in Jerusalem; and that thereafter the general, and, in short, the eternal resurrection and judgment of all men would likewise take place."), _c('a', {
    attrs: {
      "id": "fn64"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("It is also possible that Revelation was known by Papias, who is cited as bearing witness to its genuineness by Andreas of Caesarea in his "), _c('i', [_vm._v("Preface to Revelation,")]), _vm._v(" written sometime in the sixth or seventh century.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Regarding, however, the divine inspiration of the book [i.e., the Revelation of John], we think it superfluous to speak at length, since the blessed Gregory (I mean the Theologian) and Cyril, and men of an older generation as well, namely Papias, Irenaeus, Methodius, and Hippolytus, bear witness to its genuineness.")]), _c('a', {
    attrs: {
      "id": "fn65"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("If this testimony does indeed go back to Papias, it would indicate that Revelation was known to exist perhaps as early as 115 CE. While Irenaeus ("), _c('i', [_vm._v("Against Heresies")]), _vm._v(" 2.22.5; 3.3.4) states that John lived into the time of Trajan, Clement of Alexandria (quoted in Eusebius’s "), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 3.23.5-6; cf. also Clement’s "), _c('i', [_vm._v("Who Is the Rich Man That Is Saved?")]), _vm._v(" 42) gives some evidence as to the timing of John’s days on Patmos when he notes:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("For after the death of the tyrant he passed from the island of Patmos to Ephesus, and used also to go when he was asked, to the neighbouring districts of the heathen ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐθνῶν")]), _vm._v("], in some places to appoint bishops, in others to reconcile with whole churches, and in others to ordain some one of those pointed out by the Spirit."), _c('a', {
    attrs: {
      "id": "fn66"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("From the context, it appears that the tyrant in question is Domitian. Such a statement would suggest that Revelation was written (or experienced) sometime during the reign of Domitian (81-96 CE). This testimony would appear to be in agreement with Irenaeus’s statement ("), _c('i', [_vm._v("Against Heresies")]), _vm._v(" 5.30.3), which seems to place the appearance of Revelation in the reign of Domitian:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("If it were necessary that his [the antichrist’s] name should be distinctly revealed in this present time, it would have been announced by him who beheld the apocalyptic vision. For that was seen no very long time since, but almost in our day, toward the end of Domitian’s reign."), _c('a', {
    attrs: {
      "id": "fn67"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("All in all, the external evidence is quite meager but would appear to confirm, if ever so slightly, suspicions that Revelation was written down near the end of the first century CE."), _c('a', {
    attrs: {
      "id": "fn68"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in21"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('i', [_vm._v("A Modest Proposal with regard to Date")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Although the evidence, both internal and external, slightly favors a late date, it appears from the text that, with perhaps one exception, John has been intentional (and successful) in disguising the date of composition from the hearers and readers. In other words, it appears that the text may intend to conceal rather than reveal the date of its composition. If so, it would seem to be more in keeping with the S/spirit of the text to respect its intentional ambiguity and look one more time for any internal indicators that might shed light on the intentions of the text.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The closest Revelation comes to offering a date for its composition may be a phrase found in 1:10, where John says, “I was in the Spirit on the Lord’s Day.” It is commonly thought that this phrase, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τῇ κυριακῇ ἡµέρᾳ")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("tē kyriakē hēmera,")])]), _vm._v(" “on the Lord’s Day”), is simply an early equivalent for “Sunday.” Evidence offered in support of this interpretation is the meaning this phrase seems to have in documents in some close temporal proximity to Revelation (i.e., "), _c('i', [_vm._v("Did.")]), _vm._v(" 14.1; Ign., "), _c('i', [_vm._v("Magn.")]), _vm._v(" 9.1; and "), _c('i', [_vm._v("Gos. Pet.")]), _vm._v(" 35, 50). On this view, Rev 1:10 is the earliest example of the evolution of this term. The accuracy of this explanation would be hard to disprove or deny, though the traditional Johannine designation for Sunday is "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τῇ . . . µιᾷ τῶν σαββάτων")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("tē mia tōn sabbatōn,")])]), _vm._v(" “on the first day of the week”). But at the same time, in a book known for its pregnant imagery, it is possible that the hearers and readers are being given more than a detail about the day of the week on which John experiences the revelation. This statement may also convey something else about the date of the document (or of the experience). By means of the phrase “on the Lord’s Day,” John may be giving his writing an eschatological date.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("On this reading, the phrase "), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("tē kyriakē hēmera")])]), _vm._v(" might very well cause the hearer to think of the OT idea of "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("יום יהוה")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("yom Yahweh,")])]), _vm._v(" “the Day of the Lord/Yahweh”). But the hearer is not likely to see here simply a reference to the OT “Day of the Lord,” but to that day as the Lord’s Day, when Jesus himself will appear to resurrect the righteous dead. As ever, the intertext that is Revelation is the point of convergence of various “texts” (people, ideas, experiences, written texts). Here the convergence includes the OT idea of the “Day of the Lord,” John’s experience “in the Spirit,” the person of the resurrected Jesus, and the anticipation of his return and the resurrection of the dead. This intertextual understanding of the phrase goes some way toward explaining why John does not simply utilize the OT language "), _c('i', [_vm._v("yom Yahweh,")]), _vm._v(" for it is that day and more! Origen comes close to this understanding when he uses "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν τῇ µεγάλῃ κυριακῇ")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("en tē megalē kyriakē,")])]), _vm._v(" “on the great Day of the Lord”) to describe the resurrection of all, which follows Jesus’ resurrection ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“on the third day.”")]), _c('a', {
    attrs: {
      "id": "fn69"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69"
    }
  }, [_vm._v("69")])]), _vm._v(" Not only would this reading of “the Lord’s Day” be consistent with the rich symbolism of the document, but it would also dovetail nicely with the eschatological context in which Rev 1:10 is located, between vv. 7-8 and vv. 12-20."), _c('a', {
    attrs: {
      "id": "fn70"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What would be the significance of this date for the book? Simply that the Lord’s Day relativizes all other days, indicating that the only day that matters is the Lord’s Day, the end of all days."), _c('a', {
    attrs: {
      "id": "fn71"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71"
    }
  }, [_vm._v("71")])]), _vm._v(" The convergence of this dimension of the phrase, with the emerging understanding of this term as a designation for Sunday, would also not be without significance for the writer and his community.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle2",
    attrs: {
      "id": "in22"
    }
  }, [_vm._v("Authorship")]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("In contrast to the issue of date, determining the authorship of Revelation is a bit more straightforward, for unlike the four gospels, Acts, Hebrews, and 1–3 John, all anonymous documents, Revelation actually names its author. In "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("point of fact, four times does this author identify himself as John, twice in the prologue (1:1, 4), once at the beginning of the inaugural vision (1:9), and once in the epilogue (22:8). However, no other appellations are given to describe this individual. No titles or additional names are used, nor does the author claim to be a physical relative of Jesus or some other authoritative figure within early Christianity. Yet, despite the scarcity of descriptive titles, much may be learned about the author from the text.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in23"
    }
  }, [_c('i', [_vm._v("John the Prophet")])])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Primarily, the text reveals that John is regarded as, and regards himself to be, a prophetic figure. Though he never technically calls himself a prophet in the text, there are numerous indicators that he does indeed fulfill this function. The book begins with a description of the revelation of Jesus Christ given by God to “his servant John,” who testifies of the things he saw and heard (1:2). The next verse (v. 3) identifies the content of what John wrote as “the words of this prophecy.” One of the primary hints as to John’s prophetic identity is the description, on at least two occasions, of John’s prophetic commissioning. The first of these commissionings is in 1:9-20, where John, “in the Spirit on the Lord’s Day,” hears a loud voice that twice instructs him to write what he sees and hears (vv. 11, 19). The second commissioning occurs in chapter 10, where John is instructed to take the open scroll from the hand of the angel and to eat it (vv. 8-9). After ingesting the scroll, he is instructed, “You must prophesy again” (v. 11). This call narrative mirrors OT call narratives, especially that of Ezekiel, virtually establishing that John is indeed a prophet.")]), _c('a', {
    attrs: {
      "id": "fn72"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72"
    }
  }, [_vm._v("72")])]), _vm._v(" John’s prophetic activity is communicated to the hearer by means of his book being closely identified with “the word of God,” “the testimony of Jesus,” and he is repeatedly being said to be “in the Spirit” during the experience of the revelation."), _c('a', {
    attrs: {
      "id": "fn73"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73"
    }
  }, [_vm._v("73")])]), _vm._v(" Rev 19:10 plays a significant role in this understanding, where it is stated, “The testimony of Jesus is the Spirit of prophecy.” John’s prophetic identity is also made known by his instructions to engage in the prophetic activity of measuring the temple (ch. 11) and by the utilization of prophetic formulas that are also found among the classic prophets."), _c('a', {
    attrs: {
      "id": "fn74"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Not only is there evidence of John’s own identity as prophet, but as noted earlier, there are also signs of prophetic activity within the community from which Revelation comes. The presence of a rival prophetess on the concrete level (2:20), along with the appearance of the false prophet on the cosmic level (16:13; 19:20; 20:10), are negative testimony that the community was indeed accustomed to prophetic activity. But such negative evidence does not stand alone, for the community represented by Revelation knows of other prophetic figures functioning within the community, such as John’s brother prophets (22:6, 9). Prophetic activity seems to have been so widespread that it is possible for Revelation to use “prophets” to describe the activity of faithful members of the community: “the prophets and the saints” (11:18), “saints and prophets” (16:6), and “the saints and the prophets” (18:24).")]), _c('a', {
    attrs: {
      "id": "fn75"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75"
    }
  }, [_vm._v("75")])]), _vm._v(" The prophetic nature of the community would say much, not only about John’s identity, but also about the way he would function as part of it. Hints in the text suggest that the brother prophets (if they need be distinguished from others in the community) might have a role in the reading (hearing and keeping) of the text at different meetings in various locations across the community. Perhaps prophetic instruction accompanied the successive multiple readings of Revelation, but well within the boundaries set by the warning with which the book concludes (22:18-19). No doubt such activity would involve the kind of “pneumatic” interpretation called for in Revelation itself. The role of the other prophetic figures within the community in the composition of the book is difficult to determine. Part of the difficulty here is owing to questions about the way in which the book was composed. Was it experienced in a short period of time, and then written up shortly thereafter, as the text suggests? Or is it the product of an extended time of reflection, as the complex literary structure would suggest? On the former view, the involvement of other members of the prophetic community would perhaps be limited to discerning responses when the prophecy is read and heard by the community in times of worship. On the latter view, it might not be hard to imagine that John’s own prophetic activity is joined by others, as together the implications of the vision(s) and their intertextual significance are creatively constructed."), _c('a', {
    attrs: {
      "id": "fn76"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The text may also reveal two other aspects of the author’s identity. First, it appears that John was from a Jewish home, as his knowledge of the OT and "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("his appreciation for the Jewish heritage would seem to make clear.")]), _c('a', {
    attrs: {
      "id": "fn77"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77"
    }
  }, [_vm._v("77")])]), _vm._v(" Second, if Rev 1:9 speaks of banishment, then something else about John’s social location is revealed. Since banishment under the Romans was reserved for royalty and members of the priesthood, the implication is that John may have come from a priestly family, as Polycrates testifies (Eusebius, "), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 5.24.3)."), _c('a', {
    attrs: {
      "id": "fn78"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in24"
    }
  }, [_c('i', [_vm._v("Writing in the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The text of Revelation indicates that John experiences this revelation while “in the Spirit” and that, while “in the Spirit,” he is commanded to write what he sees and hears. It is clear from this and other dimensions of the text that John regards the document as carrying a spiritual authority; one might even say that he seems to regard the words of this prophecy as an “inspired” document. To speak of writing “in the Spirit” in a discussion of authorship would therefore appear to be most appropriate. But what does it mean to write “in the Spirit”?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Obviously, given that John is “in the Spirit” when he is given the command to write and that “in the Spirit” he experiences the revelation, there is a very tight interplay between the experiences of seeing and hearing and the experience of writing. But can anything else be said of this phenomenon? While it is possible to treat John primarily as an exegete of OT Scripture"), _c('a', {
    attrs: {
      "id": "fn79"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79"
    }
  }, [_vm._v("79")])]), _vm._v(" or to view him as a passive instrument who simply records what is seen or heard in an automatic fashion, neither of these conceptions appears to fit the situation envisioned by the text.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The text says that John saw a vision. But what did he see, and how much of what he saw made sense to him because of who he was? The concrete dimensions of his visionary experience notwithstanding, does John see the vision he does because of who he is and how he is formed? If some other early Christian experienced the revelation, would it look the same, or would it take a different form? Or does the Spirit use "), _c('i', [_vm._v("John’s")]), _vm._v(" knowledge of the OT for the vision to take "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("the form it does? If so, then the intertext that is John’s life, his acquaintance with the OT, apocalyptic traditions, the Jesus tradition, his worshipping community, and the experience of the revelation itself is used “in the Spirit” to produce the text of Revelation. On this understanding, we can view Revelation as the point of dynamic convergence and intersection of all that John is, including the revelation he experiences. Consequently, it is precisely because of John’s knowledge of the OT, the apocalyptic tradition, the Johannine Jesus tradition, and the worshipping community of which he is a part that enables him to write “in the Spirit.” One might go so far as to say that John’s life is such that he is especially prepared for this prophetic activity, which the Spirit integrates into a profound “inspired” text. On this view, the tension between (1) the text’s claim that this is a visionary experience and (2) the document’s intricate design and literary complexity, which suggest that it is the product of a long period of time, gives way to the Spirit’s encountering John in such a way that the convergences take place before his very eyes (and ears). Perhaps the phenomenon of glossolalia and its interpretation in contemporary Pentecostalism might function as an analogy, where the Spirit speaks through an individual believer in ways that draw upon all that he or she is, while not obliterating his or her heritage or personality.")]), _c('a', {
    attrs: {
      "id": "fn80"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in25"
    }
  }, [_c('i', [_vm._v("John the Prophet and the Other Johannine Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Understanding the relationship between Revelation and the Fourth Gospel and 1–3 John has presented a perennial challenge to NT interpreters. Though commonly identified as part of the Johannine community, there is some question whether Revelation was an integral part. A brief comparison indicates some of the reasons for these attitudes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the one hand, there are numerous points of continuity among the documents. In both the Fourth Gospel and Revelation a great deal of emphasis is placed upon the issue of witness or testimony. The anticipation of persecution owing to one’s witness found in the Fourth Gospel (16:1-4) gives way in Revelation to the reality of such persecution (2:3, 9-10, 13). “Word of God” is a theme common to the three major community documents (Fourth Gospel, 1 John, and Revelation). It has already been noted how the pneumatology shows signs of development from the Fourth Gospel to 1 John to the full-blown prophetic pneumatology of Revelation. A final example is the way in which the “revelation of Jesus Christ,” to which Revelation is devoted, accomplishes this task by following the revelation of his identity by means of the imagery of the "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Lamb. The paschal overtones of the lamb imagery in the Fourth Gospel (1:29; 19:33-34), while present in Revelation (5:6), are supplemented by a vision of the wrath of the Lamb (6:16-17), who is powerful in battle.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("On the other hand, there are several differences between these documents. Perhaps the most notable differences to readers of the Greek NT are those of vocabulary, phraseology, style, and syntax.")]), _c('a', {
    attrs: {
      "id": "fn81"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81"
    }
  }, [_vm._v("81")])]), _vm._v(" Some of these differences in vocabulary and style were noted as early as the third century. Such differences may be taken to imply that the hands of different writers are to be detected in these documents. At the same time, the grammatical style of Revelation is very curious, and there may be more than one way to interpret the evidence. Quite clearly there are significant differences between these texts. One of the results emerging from additional analyses of the grammar of the book, however, is the belief by some that the style of Revelation reflects the author’s intention to confront the hearers and readers with a style that replicates that of the OT prophets. Such a device would not only have implications with regard to the prophetic genre of the book"), _c('a', {
    attrs: {
      "id": "fn82"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82"
    }
  }, [_vm._v("82")])]), _vm._v(" but also have affective and dispositional implications for its hearers as well."), _c('a', {
    attrs: {
      "id": "fn83"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83"
    }
  }, [_vm._v("83")])]), _vm._v(" In keeping with what has earlier been observed about John “writing in the Spirit,” it might not be going too far to ask whether it is not rather the prophetic experience itself that explains the employment of the prophetic language and style found in Revelation."), _c('a', {
    attrs: {
      "id": "fn84"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn84"
    }
  }, [_vm._v("84")])]), _vm._v(" Such an interpretation would fit nicely both with John’s immersion in the OT prophetic literature and the phenomenology of his prophetic experience, while leaving open issues related to authorial intent."), _c('a', {
    attrs: {
      "id": "fn85"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn85"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The differences between the documents are indeed enough to suggest that different writers produced the Fourth Gospel and 1–3 John, on the one side, and Revelation, on the other. Yet, if the style of Revelation is an intentional strategy or the result of John’s prophetic experience, and there are substantial similarities between the documents, then one should not assume that the author is "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("incapable of writing in different styles.")]), _c('a', {
    attrs: {
      "id": "fn86"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn86"
    }
  }, [_vm._v("86")])]), _vm._v(" Such differences in writing style do seem to occur in Luke, where the first two chapters appear more Semitic in nature than do the chapters that follow."), _c('a', {
    attrs: {
      "id": "fn87"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn87"
    }
  }, [_vm._v("87")])]), _vm._v(" In addition, there is always the possibility that other hands were involved in assisting the writer in the process of composition.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in26"
    }
  }, [_c('i', [_vm._v("John in Early Christian Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("How does this emerging picture of the author of Apocalypse fit with the testimony about authorship found in the early church? The earliest extant witness is that of Justin Martyr ("), _c('i', [_vm._v("Dialogue with Trypho")]), _vm._v(" 81.4), cited in the discussion on date above. There it was seen that Justin identifies the author as “John, one of the apostles of Christ.” It would appear safe to assume that Justin believes that John the son of Zebedee wrote Revelation. Part of the strength of Justin’s testimony is that he actually lived in Ephesus for a while in the first half of the second century. Similar testimony continues to be found among various early Christian writers. Tertullian identifies the author as “the apostle John” ("), _c('i', [_vm._v("Against Marcion")]), _vm._v(" 3.14.3; 3.24.4), as do Clement of Alexandria ("), _c('i', [_vm._v("Who Is the Rich Man That Is Saved?")]), _vm._v(" 42) and Hippolytus ("), _c('i', [_vm._v("De Antichristo")]), _vm._v(" 18, 36-42).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The evidence from Irenaeus is in some ways the most extensive and, at the same time, perhaps the most frustrating. For while Irenaeus may believe that the son of Zebedee wrote Revelation, he never actually calls him an apostle, preferring simply to use the name John without other attribution ("), _c('i', [_vm._v("Against Heresies")]), _vm._v(" 1.26.3; 4.14.2; 5.26.1), or the Fourth Gospel designation “the Lord’s disciple” ("), _c('i', [_vm._v("Against Heresies")]), _vm._v(" 4.20.11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not everyone in the early church agreed with such an assessment. Perhaps the best known of the dissenting voices is that of Dionysius. whom Eusebius quotes extensively on this subject ("), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 7.25.1-27). In this testimony Dionysius notes that some not only reject John as the author but even go so far as to attribute it to Cerinthus, his archenemy (7.25.2-3). Dionysius says:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("That, then, he was certainly named John and that this book is by one John, I will not gainsay; for I fully allow that this book is by some holy and inspired person. But I should not readily agree that he was the apostle, the son of Zebedee, the brother of James, whose are the Gospel entitled according to "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("John and the Catholic epistle. For I form my judgement from the character of each and from the nature of the language and from what is known as the general construction of the book, that [the John therein mentioned] is not the same. (7.25.7-8a)")]), _c('a', {
    attrs: {
      "id": "fn88"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn88"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Dionysius goes on to point out the following differences: Revelation names its writer, the gospel and epistles do not (7.25.8b-11); the gospel and epistles share numerous ideas and vocabulary, while Revelation is utterly different (7.25.17-24); and the style and grammar of the gospel and epistles are in faultless Greek, while that of Revelation “is not accurate” and employs “barbarous idioms” that are too many to number (7.25.25-26). Lest he be misunderstood, Dionysius adds, “For I have not said these things in mockery (let no one think it), but merely to establish the dissimilarity of these writings” (7.25.27)."), _c('a', {
    attrs: {
      "id": "fn89"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn89"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given the testimony cited above, the question must be raised whether John the son of Zebedee can be identified with the John of Revelation. While it is theoretically possible to make this identification, there are at least three complications that should be noted."), _c('a', {
    attrs: {
      "id": "fn90"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn90"
    }
  }, [_vm._v("90")])]), _vm._v(" First, there is no evidence until the latter half of the second century that the son of Zebedee was ever in or near Ephesus. Ignatius, writing to the church at Ephesus ca. 110-15, makes no mention of John but goes to great lengths to demonstrate his own close relationship to Paul. Although others claim (Irenaeus, in particular) that both Polycarp and Papias had a personal relationship with the son of Zebedee, neither Polycarp nor Papias makes such a claim. Second, some evidence exists suggesting that John the son of Zebedee was martyred early in the church’s history. In Mark 10:39 Jesus appears to prophesy the martyrdom of both James and John, while Papias, as quoted by Philip of Side (ca. 430), states that both James and John were killed by the Jews."), _c('a', {
    attrs: {
      "id": "fn91"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn91"
    }
  }, [_vm._v("91")])]), _vm._v(" Third, if the son of Zebedee were the author, it would indeed be odd that he never identifies himself as an apostle and is so reticent to use apostolic language. Only three times does the term "), _c('i', [_vm._v("apostolos")]), _vm._v(" appear in Revelation. Once the term is used to describe “those who claim to be apostles but are not” (2:2), once it appears in a voice (from heaven?) celebrating the downfall of Babylon (18:20), and once it appears in the description of New Jerusalem, where the names of the twelve apostles of the Lamb are said to appear "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("on the twelve foundations of the wall of the city (21:14). In this last text it appears that the author of Revelation sees himself as distinct from this “foundational” group (from another generation?). In the end, there seems to be little reason to identify the author of Revelation as the son of Zebedee.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Is it possible to identify the author of Revelation with John the Elder, who is sometimes identified as the Beloved Disciple, the author of the other Johannine documents?")]), _c('a', {
    attrs: {
      "id": "fn92"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn92"
    }
  }, [_vm._v("92")])]), _vm._v(" Such an identification would explain the relationship between the name John, which appears in the text of Revelation and the titles of the gospel and epistles. It would further explain the virtual absence of apostolic language in the Johannine literature and the treatment of the apostles as a foundational group at some distance from the author. It would perhaps also explain why the son of Zebedee, an apostle, is not mentioned by Ignatius in his letter to the Ephesians. On this view the Elder, not being one of the Twelve, would perhaps not be on the Ignatian radar screen. This identification would also have in its favor the fact that both John the Prophet and John the Elder could independently be placed in, or around, Asia. The former is of course placed off the coast of Asia near the book’s beginning and clearly knows a number of the churches in Asia, as the seven prophetic messages imply. The latter appears to be one of the Asiatic sources from which Papias of Hierapolis ("), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 3.34.2) draws. Papias appears to have actually interviewed the Elder, perhaps in Asia, where he is said to have interviewed Philip (3.39.8-17). Such an explanation is possible, but is it plausible? The answer to this question will depend in large part on how one accounts for the differences in vocabulary, phraseology, style, and syntax that exist between the Johannine documents. If John the Prophet is thought to be John the Elder, such an identification would require that either John purposely adopted a style different from his normal one or that such a style was generated from his prophetic experience. Or it would require that he composed Revelation himself, while relying on the assistance of others in the composition of the Fourth Gospel and 1–3 John, which the texts themselves may imply."), _c('a', {
    attrs: {
      "id": "fn93"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn93"
    }
  }, [_vm._v("93")])]), _vm._v(" But in the end, it is impossible to be certain about this identification. Consequently, perhaps the best course of action is simply to hear the voice of John the Prophet alongside the other Johannine voices, content with the knowledge that they come from the same community if not the same hand."), _c('a', {
    attrs: {
      "id": "fn94"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn94"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle2",
    attrs: {
      "id": "in27"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Revelation and Its Streams of Influence: The History of Effects")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("Revelation has had an extraordinary influence upon a variety of hearers and readers throughout the centuries. Not only do the varied responses generated by Revelation reveal something of the document’s power, but they also suggest that attention paid to specific responses will enrich one’s own grappling with this remarkable text. In this section, the book’s effective history is selectively reviewed by surveying a few examples from the following categories: disastrous interpretations of Revelation, other apocalyptic “Johannine” documents, art, music, poetry, film, and commentaries.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in28"
    }
  }, [_c('i', [_vm._v("Disastrous Interpretations of Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("When pondering the effective history of Revelation, perhaps one of the first things to cross the interpreters’ minds is what we could call the disastrous interpretations of the book that have occurred over the centuries. Of the many such interpretations, I choose three as representative and describe their results, all of which involve the loss of life owing to the interpretations espoused.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("During the sixteenth century a convergence of influences produced one of the most bizarre and tragic events in the effective history of Revelation. Within a decade of the infamous Peasant Revolt of 1524-25, with which the influential Reformation figure Thomas Müntzer became involved, and the devastating defeat in the battle of Frankenhausen, where Müntzer was captured and eventually put to death, another social uprising occurred, fueled in part by the fire of Revelation, namely, the acquisition and transformation of the city of Münster. The seeds for the establishment of the Anabaptist kingdom of Münster may be found in the thought and writings of the prophetic figure Melchior Hoffmann, whose commentary on Revelation identified the emperor as the dragon, the pope as the beast, and the monks as the false prophets. Owing to various prophetic encounters and experiences, Hoffmann became convinced later in his life that (1) he was the Elijah that was to come and that the corresponding Enoch was either Cornelius Poldermann of Middleburg or Caspar Schwenckfield; (2) the spiritual Jerusalem was the present Christian community, which he identified with Strassburg; (3) the downfall of Babylon (i.e., all priests) must take place before the coming of the Lord; (4) an earthly theocracy must be established in the intervening period; and (5) violence could be used in ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("the annihilation of the godless.")]), _c('a', {
    attrs: {
      "id": "fn95"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn95"
    }
  }, [_vm._v("95")])]), _vm._v(" Though Hoffmann’s views proved too much for the authorities in Strassburg, leading to his arrest there, his teaching won many adherents from the populace in the city of Münster in Westphalia. Upon Hoffmann’s arrest, a Dutch baker from Haarlem named Jan Matthys became the inspirational leader of the movement, identifying himself as Enoch who is to come and sending word that it was time to raise the 144,000 warriors of which Rev 7 and 14 speak."), _c('a', {
    attrs: {
      "id": "fn96"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn96"
    }
  }, [_vm._v("96")])]), _vm._v(" Seizing control of the city council, he and his followers sought to establish the New Jerusalem by, among other things, driving from the town all Catholics and Protestants who refused rebaptism. As a result of the various proceedings, an army from the bishop of Münster surrounded the city. Though being victorious in previous encounters, this time Matthys and several followers were killed in a skirmish just outside the city walls. It appears that at this point one of his “apostles,” Jan Bockelson, became the unchallenged ruler of the kingdom, pronouncing himself king of the city, eventually instituting the practice of polygamy,"), _c('a', {
    attrs: {
      "id": "fn97"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn97"
    }
  }, [_vm._v("97")])]), _vm._v(" and seeking to export this eschatological movement to other cities throughout Europe."), _c('a', {
    attrs: {
      "id": "fn98"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn98"
    }
  }, [_vm._v("98")])]), _vm._v(" The kingdom died a somewhat rapid death, however, falling in 1536, along with the capture, torture, and execution of its king. Thousands lost their lives as a result of these disastrous interpretations of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("During the summer of 1969, Los Angeles, California, was shocked by the ruthless ritualistic murders that occurred on Saturday, 9 August, of Steven Earl Parent, Voytek Frykowski, Abigail Folger, Sharon Tate Polanski, and Jay Seabring, and on the following night, the murders of Leno and Rosemary La-Bianca. Though baffling to police investigators for some time, the bizarre clues of the murder scene would serve to reveal the motives for these horrendous acts. As Deputy District Attorney Vincent Bugliosi would discover, these terrible acts were in part the result of the disastrous interpretation of the book of Revelation by Charles Manson."), _c('a', {
    attrs: {
      "id": "fn99"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn99"
    }
  }, [_vm._v("99")])]), _vm._v(" The illegitimate son of a teenage mother who repeatedly abandoned him, Charles Manson would spend most of his life in a variety of institutional settings, owing both to his frequent abandonment and to the local, state, and federal crimes that he committed. Upon his release after the "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("completion of a ten-year prison sentence, Manson gathered a number of followers, who became known as the Manson Family, over whom he exerted near total and absolute control. As the deputy district attorney who prosecuted the case discovered, the motivation for these savage murders was grounded in Manson’s interpretation of the book of Revelation. For Manson, Rev 9 held the key. He identified the four angels of this chapter, who would kill a third of humankind, as referring to the four-member rock band the Beatles. The following details confirmed this interpretation for Manson: (1) the four angels would, like the locusts who arise from the Abyss, have the faces of men; (2) hair as that of a woman, an obvious reference to the long-haired look of the Beatles; (3) fire coming from their mouths, taken as a reference to the influence of their words; and (4) breastplates of fire, seen as a reference to their electric guitars. Manson thought of himself as the angel who held the key to the bottomless pit, from which all manner of evil would arise and which would be a place of refuge for him and his followers. This hermeneutical key enabled Manson to interpret a number of songs from the Beatles’ so-called White Album (officially entitled simply “The Beatles”) as prophesying an imminent racial war in which blacks would rise in revolt against white oppression. Manson hoped to initiate this cataclysmic bloodbath, which he called Helter Skelter, a phrase he took from the Beatles’ song by that title, by directing murderous activities that would gain national, if not global, attention. In the end, his apostles of murder savagely butchered seven people in Los Angeles. When questioned by the deputy district attorney about his role in the murders, Manson responded, “It’s the Beatles, the music they are putting out. They’re talking about war.”")]), _c('a', {
    attrs: {
      "id": "fn100"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn100"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, one of the better-known disastrous interpretations of Revelation resulted in the horrendous events that took place on 19 April 1993 in Waco, Texas. Here, eighty members of a religious group known as the Branch Davidians met their death in a fiery confrontation with the Federal Bureau of Investigation following an extended siege of the community."), _c('a', {
    attrs: {
      "id": "fn101"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn101"
    }
  }, [_vm._v("101")])]), _vm._v(" With roots deep in Seventh-day Adventist thought, and more specifically the “Shepherd’s Rod” movement, the leader of this group had come to have specific ideas about his own prophetic role, as well as the identity of the second beast of Rev 13 and 17. The son of an unwed teenage mother, Vernon Wayne Howell struggled in, and eventually dropped out of, high school, owing in part to dyslexia. After claiming "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("a born-again experience in a Baptist church, he made his way to the church of his mother, the Seventh-day Adventist Church. He followed this trajectory to the Shepherd’s Rod movement, and then to Davidian Seventh-day Adventism, a group from which the Branch Davidians came, and located on property they called Mount Carmel. Eventually assuming leadership of the group, Howell later changed his name to David Koresh, drawing upon the biblical name David, as well as the name Cyrus (from Heb. "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("כורשׁ")]), _vm._v("), who he said came to destroy Babylon, a task in which he would share. While his interpretations drew heavily from the traditions to which he was heir, Koresh seemed to sharpen the somewhat standard identification of the lamb-like beast of Rev 13 as the United States of America. Consequently, his extended confrontation with governmental representatives such as the Bureau of Alcohol, Tobacco, Firearms, and Explosives, and later the FBI, reinforced this identification for Koresh, especially when his compound was surrounded by the lamb-like beast, who, he was convinced, sought to persecute and kill him. At the end of an extended siege, the FBI moved on the compound, and when the smoke cleared from the resulting fires, eighty members of the community, including women and children, were dead, including Koresh, who died from a gunshot to the head.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But the effective history of Revelation is far richer than a chronicling of its disastrous interpretations, as is seen in the following sections.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in29"
    }
  }, [_c('i', [_vm._v("Other Johannine Apocalyptic Documents")])])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("One of the places where the influence of Revelation may be seen is its role in generating other Johannine apocalyptic literature. Although this aspect of the book’s effective history is not always fully appreciated, it is not surprising that Revelation has acted as a catalyst in the production of other Johannine apocalyptic documents.")]), _c('a', {
    attrs: {
      "id": "fn102"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn102"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first document that may safely be identified as being located in the Johannine apocalyptic trajectory is a work known as the "), _c('i', [_vm._v("Second Apocalypse of John (2AJ).")]), _c('a', {
    attrs: {
      "id": "fn103"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn103"
    }
  }, [_vm._v("103")])]), _vm._v(" Structurally, this book (which may be dated as early as ca. 400 or as late as the ninth century)"), _c('a', {
    attrs: {
      "id": "fn104"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn104"
    }
  }, [_vm._v("104")])]), _vm._v(" takes the form of a series of questions raised by “righteous John” and answered by “our Lord Jesus Christ.” The temporal "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("location of this apocalypse is “after the ascension” on Mount Tabor, the traditional site of Jesus’ ascension ("), _c('i', [_vm._v("2AJ")]), _vm._v(" 1). The influence of the Revelation of John is evident at many places throughout the document. After praying for seven days, the heavens are opened, and John sees a book sealed with seven seals (2-3). Later, this book is opened by the Lamb (18-19). The imagery of Revelation (esp. ch. 21) is also quite apparent at the close of the "), _c('i', [_vm._v("2AJ")]), _vm._v(" (27), where the nature of existence in heaven is described in some detail. Many of the issues addressed in the "), _c('i', [_vm._v("2AJ")]), _vm._v(" are very much what one might expect to be of interest to those who know Revelation and other early Christian documents dealing with various eschatological topics. For example, one of the first topics discussed in the "), _c('i', [_vm._v("2AJ")]), _vm._v(" concerns "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ ἀρνητῆς")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("ho arnētēs,")])]), _vm._v(" “the denier”), also known as "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ ἀντίχριστος")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("ho antichristos,")])]), _vm._v(" “the antichrist”). Specifically, there is a description of his physical appearance (7) and the length of his reign (8). Other topics addressed include the nature of the resurrection body (10-11), the descent of the heavenly things to earth (17), the order of divine judgment upon the Greeks, the Heretics, the Hebrews, and the baptized (20), the depth of the Underworld, where the unclean spirits and the Adversary are located (20), and the proportionality of punishment, based upon one’s social location (24).")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Another apocalyptic text that stands within Revelation’s stream of influence is the "), _c('i', [_vm._v("Apocalypse of St. John Chrysostom (AStJC).")])]), _c('a', {
    attrs: {
      "id": "fn105"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn105"
    }
  }, [_vm._v("105")])]), _vm._v(" This document, whose date appears to be somewhere between the sixth and eighth centuries, resembles the "), _c('i', [_vm._v("2AJ")]), _vm._v(" in that it too takes the form of a dialogue between Jesus and John the Theologian, again known as “righteous John.” Unlike "), _c('i', [_vm._v("2AJ,")]), _vm._v(" the fifty-one verses that compose the "), _c('i', [_vm._v("AStJC")]), _vm._v(" are not as concerned with eschatological details as they are with contemporary issues of relevance. The first issue raised by John and addressed by Jesus deals with the number of different kinds of sins and the identification of those sins deemed to be unforgivable (1-4). This initial discussion is followed by one devoted to how one’s actions honor or dishonor Sunday (5-10), which evolves into a discourse on the nature and purpose of fasting (8-19). Of particular interest is the use of the word for Sunday in the "), _c('i', [_vm._v("AStJC,")]), _vm._v(" being the same word as found in Rev 1:10, when John says, “I was in the Spirit on the Lord’s Day ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κυριακῇ")]), _vm._v(", "), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("kyriakē")])]), _vm._v("].” The final thirty-two verses of this document are devoted to explanations about a variety of liturgical practices (20-51). These issues range from an explanation of the symbols of the church, the individuals involved in worship, words and phrases used in worship, and even the length of hair for men and women involved in baptism and communion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Third Apocalypse of John (3AJ)")]), _vm._v(" continues to give evidence of Revelation’s influence upon other Johannine apocalyptic documents. Like the first two documents described in this section, this book also incorporates the dialogue format, only in this case the dialogue takes place between St. John the Theologian and James the Lord’s brother. The primary focus of "), _c('i', [_vm._v("3AJ")]), _vm._v(" is the fate of sinners and the righteous.")]), _c('a', {
    attrs: {
      "id": "fn106"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn106"
    }
  }, [_vm._v("106")])]), _vm._v(" After an introductory question as to when the soul leaves the body (1), there is an extended description of the fate of unrepentant sinners (2-10). Angelic guides lead sinners to torment that lasts forever, including the river of fire and the worm that never dies. The next major section of "), _c('i', [_vm._v("3AJ")]), _vm._v(" (11-35) focuses upon the fate of the righteous, who, full of light, pass over the torments of the unrepentant. Worthy of mention from this section is the catalog of sinners who are offered as examples of recipients of God’s grace as a result of their repentance (23-27). Included in this list are Peter, who denied the Lord three times (23); Mary the prostitute, who had sinned indiscriminately with 1,703 men; Manasseh, who killed his own son; 40 elders, as well as Isaiah; the thief on the cross, who had committed 99 murders (24); David, who sinned with Bathsheba, one of 100 women he kept (25); Andrew of Crete, who committed incest with his own mother but later became a bishop (26); and Cyprian, who was born of a race of demons and destroyed 1,300 children before his conversion and call as a bishop (27). The document concludes with a warning that there is no opportunity for repentance or forgiveness after one’s death (35). Clearly, the document’s major emphasis is upon the importance of repentance and God’s free forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A final document to be mentioned in this section devoted to Revelation’s influence upon later Johannine apocalyptic texts is the "), _c('i', [_vm._v("Coptic Apocalypse of John (CAJ).")]), _c('a', {
    attrs: {
      "id": "fn107"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn107"
    }
  }, [_vm._v("107")])]), _vm._v(" This work, which appears to date from the eleventh century, continues the now-familiar dialogue format found in the previous three books described. On the Mount of Olives, just before the ascension of Jesus, John the apostle and the Holy Virgin request that he be taken to heaven by Jesus in order to see all the mysteries contained therein. Granting his request, Jesus entrusts John to “a great cherubim” ["), _c('i', [_vm._v("sic")]), _vm._v("] covered with eyes who could answer all John’s questions, for the words of the Father are hidden within the cherubim (2). John’s journey includes a visit to the seven heavens. Here he discovers that water, which existed before the creation of heaven and earth (3), is scarce at times owing to the sin of humanity. He finds that Michael is an unrivaled angelic being whose name "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("is found upon the garments of all angels who come to earth because his name keeps such ones from being led astray by the devil (7). John discovers that Eve was hidden in Adam’s rib from his creation and separated from him later (13). He finds that after Solomon had the demons reveal the origins of illness and their remedies, he inscribed them on a wall of the temple. Hezekiah plastered over this information, and when he was found in need of healing, Hezekiah prayed and was sent the prophet Isaiah with the remedy (14). Finally, John is told that God determines a soul’s destiny and that animals also have souls, though they always remain on earth (18).")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in30"
    }
  }, [_c('i', [_vm._v("Art")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("The influence of Revelation upon countless artists is hard to overestimate. In fact, it is not going too far to say that artists have been among the most attentive interpreters of Revelation. The reason for this is not difficult to ascertain, for the book’s aesthetic beauty speaks very powerfully to those with artistic sensibilities and connects with them at very deep levels. Thus, while the sometimes bizarre imagery of Revelation can serve to frighten off certain textually inclined individuals, this same imagery often proves to be an irresistible invitation to the imaginations of various artists who devote their energies to artistic conceptualizations of Revelation. The influence of Revelation in the realm of art is so vast, the challenges involved in attempting to describe artistic depictions without benefit of the visual images themselves so great, that one could almost despair of attempting to include a section in this part of the introduction devoted to history of effect. The significance of this voluminous evidence, however, necessitates the inclusion of a survey of the art inspired by Revelation, despite the limitations of the presentation.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("The effective history of Revelation in art can be detected as early as the depictions of scenes from Revelation found within the catacombs in Rome. Here, among the numerous representations drawn from both the OT and the NT, appear to be drawings inspired by Revelation. One example is a picture of Christ the Judge, surrounded by stacks of books, the basis of the judgment of the dead (cf. Rev 20:12), and sheep, which represent the elect.")]), _c('a', {
    attrs: {
      "id": "fn108"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn108"
    }
  }, [_vm._v("108")])]), _vm._v(" Other depictions informed by Revelation include the conquering Christ entering the holy city in triumph and Christ teaching the multitude in the heavenly Jerusalem."), _c('a', {
    attrs: {
      "id": "fn109"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn109"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("One of the ways to gain entry into the art of Revelation in general is to become aware of the variety of media used in creating these artistic depictions. These media include the following (with an example of the medium provided within parentheses):")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('ul', {
    staticClass: "disc"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('li', [_vm._v("illuminated manuscripts ("), _c('i', [_vm._v("The Trinity Apocalypse,")]), _vm._v(" Trinity College Library, Cambridge),")]), _vm._v(" "), _c('li', [_vm._v("oil paintings (Raphael’s "), _c('i', [_vm._v("The Vision of Ezekiel")]), _vm._v("),")]), _vm._v(" "), _c('li', [_vm._v("stained glass (the Great East Window of York Minster),")]), _vm._v(" "), _c('li', [_vm._v("frescoes (Correggio’s Painted Cupola, Giovanni Evangelista at Parma),")]), _vm._v(" "), _c('li', [_vm._v("mosaics (the Triumphal Arch of S. Maria Maggiore in Rome),")]), _vm._v(" "), _c('li', [_vm._v("relief sculptures ("), _c('i', [_vm._v("Majestas Domini,")]), _vm._v(" Chartres [Eure-et-Loir], Notre Dame, Portail Royal), and")])]), _c('li', [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("tapestries (The Brussels Tapestries).")]), _c('a', {
    attrs: {
      "id": "fn110"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn110"
    }
  }, [_vm._v("110")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Another avenue by which to gain some understanding of the effective history of Revelation in the realm of art is to give some attention to the scenes from Revelation that are most often depicted. One of the more popular scenes among artists is the attempt to depict John near the beginning of his visionary experience. Sometimes the focus is upon John taking the book from the angel or writing in it, though often these scenes include some aspect of the vision that awaits John. One of the best examples is the well-known fifteenth-century altarpiece by Hans Memling "), _c('i', [_vm._v("(St. John the Evangelist on Patmos).")]), _vm._v(" In this oil on wood painting, John sits writing in the foreground, while in the background many of the prominent aspects of the vision are depicted.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another very popular theme among artists of Revelation is the vision of heaven in chapters 4–5. Also prominent are depictions of angelic beings. Not surprisingly, special attention is given to the seven angels with the seven trumpets (8:2), the sounding of which accompanies significant events on the earth, the seven angels with the seven bowls of judgment (ch. 15), as well as the angels who accompany and/or speak with John during the course of the visionary drama. Equally influential are the images of the opening of the seven seals and the Four Horsemen, who accompany the opening of the first four of these seals. Other prominent images of Revelation to be found in art include the four living beasts, the woman clothed with the sun, the beast and the dragon, and Babylon the "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("harlot. As could be expected, much attention is devoted to depictions of the new heaven and new earth.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Yet another way to gain some appreciation for the art inspired by Revelation is to give attention to a few individual contributions of special significance. Some of the most exquisite and moving artistic depictions of scenes from Revelation are to be found in a group of illuminated manuscripts that contain a commentary on the book of Revelation written sometime during the eighth century by Beatus, a resident of the Benedictine abbey of Santo Turibio at Liébana, Spain. The commentary Beatus produced could more properly be considered a catena, a collection of comments from a variety of earlier writers.")]), _c('a', {
    attrs: {
      "id": "fn111"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn111"
    }
  }, [_vm._v("111")])]), _vm._v(" Several illuminated manuscripts appeared over the next few hundred years that illustrate a number of scenes from Revelation. It appears that the original cycle of illustrations consisted of 108 somewhat disparate images. Of these, one illustration accompanies each chapter of text as well as an introductory image. These illustrations are among the most beautiful and emotive devoted to Revelation."), _c('a', {
    attrs: {
      "id": "fn112"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn112"
    }
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1498 Albrecht Dürer produced a series of fifteen woodcuts based on Revelation, which brought him immediate fame. These black-and-white depictions are staggering in terms of their vision, intricacy, and detail. Introduced by a depiction from "), _c('i', [_vm._v("The Life of John,")]), _vm._v(" where John is in a cauldron of oil, they include many of the major scenes from Revelation. His work, considered by many to have superseded everything that preceded it, inspired other scenes by later artists in order to complement those offered by Dürer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Perhaps the single, best-known artistic depiction generated by Revelation is "), _c('i', [_vm._v("The Adoration of the Lamb,")]), _vm._v(" by Jan van Eyck, which is part of the Ghent Altarpiece. While any artistic depiction of a scene from Revelation involves interpretation on the part of the artist(s), the integrative vision that produces "), _c('i', [_vm._v("The Adoration of the Lamb")]), _vm._v(" may be without rival. The focal point of the scene, as the name indicates, is the Lamb standing upon an altar with his blood from an open wound flowing directly into a chalice. He is surrounded by angels, two of whom continually minister incense around him, while twelve others are given to other forms of adoration. For example, two of the twelve stand on either side of a large wooden cross that they gently embrace, a crown of thorns in the hand of one and a spear in the hand of the other. In the background is a sunlike sphere, the rays of which disperse in all directions, from which the Spirit as a dove descends. All around the Lamb are groups of saints who worship "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("him. These include the martyrs, confessors, virgins, apostles, prophets, pilgrims, and soldiers of the cross. In the foreground is the fountain of the water of life, which the death of the Lamb makes available to all who believe (Rev 22:1-2). The indescribable beauty of "), _c('i', [_vm._v("The Adoration of the Lamb")]), _vm._v(" makes it one of the most magnificent pieces of the artistic effective history of Revelation.")]), _c('a', {
    attrs: {
      "id": "fn113"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn113"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in31"
    }
  }, [_c('i', [_vm._v("Music")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("When reflecting upon Revelation’s effective history in the realm of music, one of the first compositions to come to mind is the “Hallelujah Chorus” in G. F. Handel’s "), _c('i', [_vm._v("Messiah.")]), _vm._v(" Written over a twenty-four-day period in 1741 (21 August through 14 September 1741),"), _c('a', {
    attrs: {
      "id": "fn114"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn114"
    }
  }, [_vm._v("114")])]), _vm._v(" this ambitious oratorio in three parts covers the life of Christ beginning with the nativity and concluding with the apocalyptic vision of the Lamb of God glorified in heaven. "), _c('i', [_vm._v("The Messiah,")]), _vm._v(" along with "), _c('i', [_vm._v("Israel in Egypt,")]), _vm._v(" consists entirely of texts taken from Scripture."), _c('a', {
    attrs: {
      "id": "fn115"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn115"
    }
  }, [_vm._v("115")])]), _vm._v(" It reaches its climax at the end of part 2, in the crescendo entitled “Hallelujah.” Relying heavily upon Rev 19:6, from which the title “Hallelujah” comes, the chorus incorporates the well-known phrase “for the Lord God Omnipotent reigneth” as a repeated refrain. This refrain then gives way to additional words that come from Rev 11:15, “The kingdom of this world is become the kingdom of our Lord and of His Christ, and He shall reign forever and ever.” As the chorus draws to its climatic conclusion, the words “King of Kings and Lord of Lords,” also from Rev 19:16, are incorporated into the vigorous, almost overpowering integration of words from these texts, words that are brought together in an extraordinary marriage of lyrics, voices, notes, and instruments. The influence of Revelation upon "), _c('i', [_vm._v("The Messiah")]), _vm._v(" is not limited to its effect upon the “Hallelujah Chorus” but continues to be seen in the oratorio’s very last chorus, entitled “Worthy Is the Lamb That Was Slain,” with which the whole composition concludes. On this occasion it is Rev 5:12-13 that provides the lyrics:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Worthy is the Lamb that was slain, and hath redeemed us to God by his blood, to receive power, and riches, and wisdom, and strength, and honour, and glory, and blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Followed by:")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Blessing and honour, glory and pow’r, be unto Him, be unto Him that sitteth upon the throne, and unto the Lamb.")])]), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("It is even possible that the “Amen” of Rev 5:14 inspires its repeated use as "), _c('i', [_vm._v("The Messiah")]), _vm._v(" concludes. When one hears "), _c('i', [_vm._v("The Messiah,")]), _vm._v(" first performed in Dublin and regularly at the Foundling Hospital in London for charitable purposes,")]), _c('a', {
    attrs: {
      "id": "fn116"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn116"
    }
  }, [_vm._v("116")])]), _vm._v(" the effect of the text of Revelation is unmistakable. However, it is possible not only to detect Revelation’s effect upon "), _c('i', [_vm._v("The Messiah")]), _vm._v(" but also to know something of this text’s effect upon the composer himself. For it is said that, upon the completion of the “Hallelujah Chorus,” Handel commented to his servant, “I think I did see all Heaven before me and the Great God Himself.”"), _c('a', {
    attrs: {
      "id": "fn117"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn117"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The effective history of Revelation upon music may also be observed in the hymns of Charles Wesley (1707-88)."), _c('a', {
    attrs: {
      "id": "fn118"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn118"
    }
  }, [_vm._v("118")])]), _vm._v(" The son of an Anglican cleric (Samuel) and a mother (Susanna) fiercely devoted to religious training, Charles worked closely with his better-known brother John. On 21 May 1738, three days before John’s experience of the assurance of his salvation (when his heart was “strangely warmed”), Charles had his own religious awakening. Often referred to as the poet of the Methodist movement, Charles eventually penned more than 6,000 hymns. Rich in biblical content and theological reflection, a significant number of these hymns clearly show the impact of Revelation. For example, in the 1904 edition of "), _c('i', [_vm._v("The Methodist Hymn-Book,")]), _vm._v(" more than 110 of Charles’s hymns make explicit reference to the words and/or imagery of the book of Revelation. Some of the hymns reflect a single idea such as the “cleansing blood of Jesus,” found in Rev 1:5 (cf. Hymn 525.1 [verse 1]; 708.5; 709.4); “following the Lamb wherever he leads,” in Rev 14:4 (541.1; 787.1; 788.1; 857.2); or “come quickly, Lord Jesus,” from Rev 22:20 (66.6; 291.4; 529.5; 546.4; 554.2; 829.6). The ideas and wording of Revelation are so embedded in the hymns of Wesley that such examples could be offered almost ad infinitum. In addition to traces of Revelation’s effective influence across a wide range of compositions, a number of Wesley’s hymns are devoted wholly to a specific text or an amalgam of texts from Revelation. The three examples selected for inclusion here each "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("reveal something of the extent to which Revelation penetrated Charles Wesley’s very soul.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The first example (Hymn 200) offers Wesley’s meditation upon the prophetic word contained in Rev 1:7:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("1"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Lo! He comes with clouds descending,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Once for favored sinners slain;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Thousand thousand saints attending,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Swell the triumph of his train:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1c"
  }, [_vm._v("Hallelujah!")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("God appears on earth to reign.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb2"
  }, [_vm._v("2"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Ev’ry eye shall now behold Him")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Robed in dreadful majesty;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Those who set at nought and sold Him,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Pierced and nailed him to the tree,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1c"
  }, [_vm._v("Deeply wailing, deeply wailing,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Shall the true Messiah see.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb2"
  }, [_vm._v("3"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("The tokens of His passion")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Still his dazzling body bears;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Cause of endless exultation")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("To His ransomed worshippers:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1c"
  }, [_vm._v("With what rapture")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Gaze we on those glorious scars!")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb2"
  }, [_vm._v("4"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Yea, Amen! let all adore thee,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("High on Thy eternal throne;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Saviour, take the power and glory,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Claim the kingdom for Thine own;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1c"
  }, [_vm._v("Jah, Jehovah,")])]), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Everlasting God, come down!")]), _c('a', {
    attrs: {
      "id": "fn119"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn119"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Another example (Hymn 802) is a moving reflection upon the description of those who passed through the great tribulation described in Rev 7:13-17:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("1"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("What are these arrayed in white,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Brighter than the noonday sun?")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Foremost of the sons of light,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Nearest the eternal throne?")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("These are they that bore the cross,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Nobly for their Master stood;")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Sufferers for His righteous cause,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Followers of the dying God.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("2"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Out of great distress they came,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Washed their robes by faith below")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("In the blood of yonder Lamb,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Blood that washes white as snow:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Therefore are they next the throne,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Serve their Maker day and night;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("God resides among His own,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("God doth in His saints delight.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("3"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("More than conquerors at last,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Here they find their trials o’er;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("They have all their sufferings passed,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Hunger now and thirst no more;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("No excessive heat they feel")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("From the sun’s directer ray,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("In a milder clime they dwell,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Region of eternal day.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("4"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("He that on the throne doth reign,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Them the Lamb shall always feed,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("With the tree of life sustain,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("To the living fountains lead;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("He shall all their sorrows chase,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("All their wants at once remove,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Wipe the tears from every face,")])]), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Fill up every soul with love.")]), _c('a', {
    attrs: {
      "id": "fn120"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn120"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("A final example (Hymn 848) draws upon the concluding chapters of Revelation, focusing upon the future reward and place of abode awaiting the saints:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("1"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Away with our sorrow and fear!")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("We soon shall recover our home,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("The city of the saints shall appear,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("The day of eternity come:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("From earth we shall quickly remove,")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("And mount to our native abode,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("The house of our Father above,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("The palace of angels and God.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("2"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("Our mourning is all at an end,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("When, raised by the life-giving word,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("We see the new city descend,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Adorned as a bride for her Lord:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("The city so holy and clean,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("No sorrow can breathe in the air;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("No gloom or affliction of sin,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("No shadow of evil is there.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("3"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("By faith we already behold")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("That lovely Jerusalem here;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Her walls are of jasper and gold,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("As crystal her buildings are clear;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Immovably founded in grace,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("She stands as she ever hath stood,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("And brightly her Builder displays,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("And flames with the glory of God.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("4"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("No need of the sun in that day,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("Which never is followed by night,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Where Jesus’s beauties display")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("A pure and a permanent light:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("The Lamb is their light and their sun,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("And lo! By reflection they shine,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("With Jesus ineffably one,")])]), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("And bright in effulgence divine.")]), _c('a', {
    attrs: {
      "id": "fn121"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Other Wesley compositions heavily influenced by Revelation include Hymns 227 and 848.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though many other examples could here be offered,"), _c('a', {
    attrs: {
      "id": "fn122"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn122"
    }
  }, [_vm._v("122")])]), _vm._v(" the work of Handel "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("and Charles Wesley illustrates the powerful influence of Revelation in the realm of music.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in32"
    }
  }, [_c('i', [_vm._v("Poetry")])])]), _c('p', {
    staticClass: "FirstPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The first example here offered of the effective power of Revelation in the world of English poetry comes from the so-called "), _c('i', [_vm._v("Gawain-")]), _vm._v("Poet. Writing near the close of the fourteenth century in the Northwest Midlands of England, the "), _c('i', [_vm._v("Gawain-")]), _vm._v("Poet produced four works contained in a single medieval manuscript. The name "), _c('i', [_vm._v("Gawain")]), _vm._v(" comes from the first poem in the manuscript, “Sir Gawain and the Green Knight.” The similarity of dialect and vocabulary, among other things, leads most scholars to conclude that these four works come from the same author.")]), _c('a', {
    attrs: {
      "id": "fn123"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn123"
    }
  }, [_vm._v("123")])]), _vm._v(" The effect of Revelation is quite pronounced in the most ambitious of the "), _c('i', [_vm._v("Gawain")]), _vm._v(" pieces,"), _c('a', {
    attrs: {
      "id": "fn124"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn124"
    }
  }, [_vm._v("124")])]), _vm._v(" a poem entitled “The Pearl.” This influence is seen in the occasional direct references to “the Apostle John” or to “the Apocalypse,” the numerous direct quotations of the book, and a variety of other more subtle appearances of the language and imagery of Revelation. One extended passage illustrates something of the extent of the theological integration of Revelation into the poetry of the "), _c('i', [_vm._v("Gawain-")]), _vm._v("Poet. The passage is devoted to reflection upon the relationship between Christ and his bride, the church.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("64")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("O spotless Lamb who doth defeat")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("All ills, my dearest Destiny")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Chose me His mate, although unmeet")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("At first had seemed that unity")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("From the world of woe I did retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("He called me to His company:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("“Come hither to me, my belovéd sweet;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("There is no mote nor spot in thee.”")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Might and beauty He gave to me.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("In His blood He rinsed my robes before")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("He crowned me clean in virginity,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Adorning me in pearls so pure.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("65")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Why, spotless bride who flames so bright,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Possessed of royalty rich and rife,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("What kind of Lamb is He who might")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Wed thee and take thee to his wife?")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Above all others thou climbedst the height")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("To lead with Him so noble a life!")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("So many, comely combed, did fight")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("For Christ and live in constant strife,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("And all those dear ones thou didst drive")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Out from that marriage and so assure")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Thy place alone, so bold and blithe,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("A peerless maid, matchless and pure.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("66")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("“Spotless,” quoth that merry queen,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Unblemished I am, without a blot,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("And that I might bear with stately mien,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("But “unmatched queen,” that said I not.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("All wives of the Lamb in bliss we have been,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("A hundred and forty thousand lot,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("As in the Apocalypse it is seen.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("St. John saw them gathered all in a knot,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("On the hill of Sion, that seemly spot.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Apostle saw them, in his vision’s dream,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Arrayed for the wedding on that hill top,")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("The fair new city, Jerusalem.")]), _c('a', {
    attrs: {
      "id": "fn125"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn125"
    }
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Another witness to the effective history of Revelation comes from the work of William Blake (1757-1827). Perhaps “the best poetry in English since Milton,” Blake’s work is widely known for its beauty, masterful design, and minute articulations."), _c('a', {
    attrs: {
      "id": "fn126"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn126"
    }
  }, [_vm._v("126")])]), _vm._v(" Traces of Revelation’s influence can be detected throughout much of the Blake corpus. For example, in “The Marriage of Heaven and Hell” (plate 19), one encounters the phrase “seven houses of brick,” which refers to the seven churches of Rev 2–3. It is sometimes argued that, if Oothoon’s search "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("for Theotormon were successful in “Vision of the Daughters of Albion,” there would be no more sea (Rev 21:1). Clear reference to Rev 11 is made in a passage from “Milton: The First Book” (plate 24, lines 59-62):")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("The witnesses lie dead in the Street of the Great City;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("No Faith is in all the Earth: the Book of God is trodden under Foot:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("He sent his two Servants Whitefield & Westley: were they Prophets")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Or were they Idiots or Madmen? shew us Miracles.")]), _c('a', {
    attrs: {
      "id": "fn127"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn127"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Also informed by Revelation (21–22) are the descriptions and measurements of Jerusalem in “Jerusalem: Chapter 1” (plates 12-13). By far the composition with the greatest concentration of Apocalypse imagery, however, is Blake’s epic “The Four Zoas.” Not only is the title taken from the four living beasts of Rev 4:6 ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τέσσαρα ζῷα")]), _vm._v(", "), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("tessara zoa")])]), _vm._v("), but there are also references to a number of terms and topics also found in Revelation. For example, the numerology of Revelation is reflected in “The Four Zoas: Night the First”:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Then they Elected Seven, called the Seven")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Eyes of God & the Seven lamps of the Almighty;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Seven are one within the other, the Seventh is named Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Lamb of God blessed forever. . . ."), _c('a', {
    attrs: {
      "id": "fn128"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn128"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("In addition to the numerology, descriptive terms like “the Synagogue of Satan” and “the Harlot of the Kings of Earth,” also known as “Mystery the Harlot,” frequently appear. Throughout the piece special standing is given to “the Lamb of God,” who, among other things, creates for himself a bride and wife. While numerous other observations could be made about the effect of Revelation upon the poetry of Blake, perhaps something of the creative integration of these powerful images in his vision might best be captured in a passage from “The Four Zoas: Night the Eighth”:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("We now behold the Ends of Beulah & we now behold")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Where Death Eternal is put off Eternally")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Assume the dark Satanic body in the Virgin’s womb")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("O Lamb divin[e] it cannot thee annoy O pitying one")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Thy pity is from the foundation of the World & thy Redemption")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Begun Already in Eternity")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Come then O Lamb of God")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Come Lord Jesus come quickly.")]), _c('a', {
    attrs: {
      "id": "fn129"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn129"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Revelation’s effective history in the realm of poetry is also evidenced within the Pentecostal tradition in a composition that appeared in 1907, written by an individual identified simply as Bro. A.Beck. The poem, entitled “The First Resurrection,” was inspired by the words of Rev 20:6, “Blessed and holy is he that hath part in the first resurrection; On him the second death has no power.”")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('b', [_vm._v("“The First Resurrection”")])]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Behold the sight most wonderful;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("From every grave beneath the skies,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("From ocean depth and mountain peak,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("The righteous dead arise.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("With bodies glorified they come,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("With faces radiant and sublime;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("With shouts of victory ascend,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("All in a moment’s time.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Changed in the twinkling of an eye,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Immortal bodies they put on;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Swifter than any lightning’s ray")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("And brighter than the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Oh, what vast and joyous host,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("When dead and living are called out,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("From silent grave, and worldly crowd,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("At the archangel’s shout.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("No wicked one amongst that host,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Shall rise to life on that great day;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The flowers above their graves still bloom,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_vm._v("Over their lifeless clay.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("In that great resurrection morn,")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Oh, grant us all a standing place;")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("That we with all the Bloodwashed saints")])]), _c('p', {
    staticClass: "QuoteSb1b"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("May see Thy blessed face.")]), _c('a', {
    attrs: {
      "id": "fn130"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn130"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in33"
    }
  }, [_c('i', [_vm._v("Film")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("While the effective history of Revelation in the medium of film is vast, this brief section focuses upon two distinct celluloid interpretations that find their raison d’être in the book of Revelation. Distinct in their emphases and target audiences, each film exhibits clear signs of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One motion picture that draws heavily upon Revelation is "), _c('i', [_vm._v("End of Days,")]), _vm._v(" a dark Arnold Schwarzenegger film. Timed for release to coincide with the turn of the millennium, the imprint of Revelation is obvious throughout. The premise of the film is that a female baby, born twenty years before the turn of the millennium, is dedicated and prepared to bear a child fathered by Satan upon his release from the Abyss. This tale of struggle at the cosmic level draws upon Revelation at a number of points as the story unfolds. Perhaps the clearest sign of Revelation’s effect upon the film is the way in which Rev 20:7 serves as a refrain throughout the piece. The words of this verse (“And when the thousand years have ended, Satan will be loosed from his prison”) appear as early as the opening credits and are read by the viewer or heard from the lips of various characters in the film on several occasions. In fact, the viewer is not permitted to allow the importance of Revelation to go unnoticed as part of the mystery of these words is revealed when Jericho (Schwarzenegger’s character) actually reads them from the Bible. The release of Satan, accompanied by explosions and earthquake-like phenomena, is depicted as a phantom-like presence who searches New York City until the right man is found, of whom Satan takes possession. The plot develops as the powers of Satan are manifested and the diverse strategies of the church are unveiled. Satan’s identity is developed in ways clearly indebted to Revelation, as both serpent and hideous beast are associated with either his activity or an image he takes on at some point. While the adulterous activities of the great "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πόρνη")]), _vm._v(" ("), _c('span', {
    staticClass: "trans"
  }, [_c('i', [_vm._v("pornē,")])]), _vm._v(" “whore”) of Rev 17–18 find no place in the film, the sexual immorality of this female figure appears to be lived out in the figure of Satan, who is sexually immoral from his first appearance to his last one. The purpose of his release, “to deceive the nations,” is represented by the numerous individuals he co-opts "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("or attempts to seduce in order to accomplish his goal. The witnesses of the church, who seek to oppose Satan at every point, meet fates similar to that of the witnesses found in Revelation. The gematria of the beast’s number (666) is inverted (999) in this movie in order to produce the meaning that Satan’s release coincides with the year 1999. The woman clothed with the sun, whose child the beast opposes in Rev 12, is transformed in this story into Christine York (Christ in New York!), who must be protected from the dragon by God and his agents, so that she "), _c('i', [_vm._v("not")]), _vm._v(" become impregnated. Her principal defender, Jericho, though a person on the verge of suicide as the movie opens — who has had a disagreement with God when his wife and daughter are ruthlessly murdered — mirrors Christ in several ways. At one point Satan, seeking the whereabouts of Christine, tempts Jericho with the promise of the return of his dead wife and daughter in exchange for the information. Perhaps the most explicit example of the similarities between Christ and Jericho is the moment in the movie when Jericho, while seeking to protect Christine, is betrayed by his best friend, attacked and beaten by a mob, finally being crucified in a dirty alleyway. Furthermore, near the conclusion of the film, Jericho renounces violence, asks God for strength, and seeks to face Satan through his faith in God/Christ. Despite Satan’s attack, which includes Satan’s entering him in order to accomplish his purpose for Christine, Jericho successfully fights off these internal struggles and, like Christ, goes to his death in order to save others. Jericho’s death not only protects Christine but also culminates in Satan’s return to the Abyss.")]), _c('a', {
    attrs: {
      "id": "fn131"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn131"
    }
  }, [_vm._v("131")])]), _vm._v(" The effect of Revelation upon this film, intended for a mainstream audience, is obvious."), _c('a', {
    attrs: {
      "id": "fn132"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn132"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A second film that shows the clear effects of the text of Revelation is "), _c('i', [_vm._v("The Omega Code,")]), _vm._v(" a TBN Ministries production. In keeping with a popular line of eschatological thought, this movie traces the rise of a world leader to a position of religious, political, and economic control. In addition to a plot readily recognizable to many (dispensational) students of “Bible prophecy,” "), _c('i', [_vm._v("The Omega Code")]), _vm._v(" utilizes in its story line the Bible Code, a recent theory that, deep within Scripture, a secret code exists that yields to painstaking numerical and linguistic analysis. The world leader of "), _c('i', [_vm._v("The Omega Code,")]), _vm._v(" Stone Alexander (played by Michael York), makes use of the Bible Code to gain dominance of the world. From the beginning of the film, where explicit reference is made "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("to the books of Daniel and Revelation, the significance of Revelation is clear. Throughout "), _c('i', [_vm._v("The Omega Code")]), _vm._v(" characters and events found in Revelation are highlighted. For example, the two witnesses described in Rev 11 figure prominently at numerous points throughout the film. Not only do they function as prophetic figures, appearing before the world on cable TV, but they are also martyred and humiliated but then raised from the dead. As the story unfolds, messages from the biblical text, discovered by means of the Bible Code, appear on a computer screen. Among the messages having clear reference to Revelation are the following:")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("TEN HORNS UNITE UNDER WORLD LEADER")]), _vm._v(" "), _c('li', [_vm._v("AROMA OF END ENCHANTS ALL FOR 3½ YEARS")]), _vm._v(" "), _c('li', [_vm._v("BLOOD POURS FROM STONE — WORLD WONDERS")]), _vm._v(" "), _c('li', [_vm._v("SEVEN HORNS BOW TO WOUNDED HEAD, and")]), _vm._v(" "), _c('li', [_vm._v("DAWN OF A NEW MILLENNIUM.")])])]), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("In addition to these messages, which act as a refrain throughout the film, there are the rebuilding of Solomon’s temple (based upon an interpretation of Rev 11), the worship of the beast and reference to his (false) prophet, a wound to the head of Alexander and his subsequent recovery, the reading of the text of Rev 13 by the two witnesses, and the appearance in a vision of the Four Horsemen, described in Rev 6. It is difficult to overestimate the significance of this and other films like it,")]), _c('a', {
    attrs: {
      "id": "fn133"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn133"
    }
  }, [_vm._v("133")])]), _vm._v(" for they represent the thinking and expectations about the end time of a significant number of Christians worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "CHTitle3",
    attrs: {
      "id": "in34"
    }
  }, [_c('i', [_vm._v("Commentaries")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara1"
  }, [_vm._v("This subsection concludes the part devoted to Revelation’s streams of influence, as well as the introduction proper. The four commentaries surveyed at this point each represent a significant contribution and movement in the study of Revelation over the centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first extant commentary on Revelation is that by Victorinus, bishop of Pettau (d. ca. 304), written sometime around 260 and preserved by Jerome. This work offers comment on a number of verses in almost every chapter, except 16 and 18. Victorinus’s interpretative approach is symbolic in nature, if not allegorical, as the following examples illustrate. Commenting on the open door John saw in Rev 4:1, Victorinus notes, “The New Testament is announced as an "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("open door in heaven.”")]), _c('a', {
    attrs: {
      "id": "fn134"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn134"
    }
  }, [_vm._v("134")])]), _vm._v(" His comments on the open book in the hand of God continue this thought, “This book signifies the Old Testament, which has been given into the hands of our Lord Jesus Christ, who received from the Father judgment.”"), _c('a', {
    attrs: {
      "id": "fn135"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn135"
    }
  }, [_vm._v("135")])]), _vm._v(" But perhaps the nature of Victorinus’s approach is captured best by his comments on Rev 6:12-14:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("12")]), _vm._v("“And I saw, when he had opened the sixth seal, there was a great earthquake.” In the sixth seal, then, was a great earthquake: this is that very last persecution.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_vm._v("“And the sun became black as sackcloth of hair.” The sun becomes as sackcloth; that is, the brightness of doctrine will be obscured by unbelievers.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_vm._v("“And the entire moon became as blood.” By the moon of blood is set forth the Church of the saints as pouring out her blood for Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("13")]), _vm._v("“And the stars fell to the earth.” The falling of the stars are the faithful who are troubled for Christ’s sake.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_vm._v("“Even as a fig-tree casteth her untimely figs.” The fig-tree, when shaken, loses its untimely figs when men are separated from the Church by persecution.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("14")]), _vm._v("“And the heaven withdrew as a scroll that is rolled up.” For the heaven to be rolled away, that is, that the Church shall be taken away.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3"
  }, [_vm._v("“And every mountain and the islands were moved from their places.” Mountains and islands removed from their places intimate that in the last persecution all men departed from their places; that is, that the good will be removed, seeking to avoid the persecution."), _c('a', {
    attrs: {
      "id": "fn136"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn136"
    }
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Victorinus offers an extensive explanation of how the numerical calculation of the number of the beast, found in Rev 13:18, works in Greek, Latin, and even Gothic. For him, there is no doubt as to the identity of the seven hills upon which the woman sits in Rev 17:9. It is “the city of Rome.” On the identity of the kings in 17:10-11, he writes:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("10")]), _vm._v("“And there are seven kings: five have fallen, and one is, and the other is not yet come; and when he is come, he will be for a short time.” The time must be understood in which the written Apocalypse was published, since then reigned Caesar Domitian; but before him had been Titus his brother, and "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Vespasian, Otho, Vitellius, and Galba. These are the five who have fallen. One remains, under whom the Apocalypse was written, Domitian, to wit. “The other has not yet come,” speaks of Nerva; “and when he is come, he will be for a short time,” for he did not complete the period of two years.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('p', {
    staticClass: "QuoteSb3"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("11")]), _vm._v("“And the beast which thou sawest is of the seven.” Since before those kings Nero reigned.")]), _c('a', {
    attrs: {
      "id": "fn137"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn137"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("In his more extensive comments on Rev 20:1-6 Victorinus appears to argue for an earthly millennial reign of Christ, at the end of which Satan will be released for a period of three and one-half years. He goes on to say:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("I do not think the reign of a thousand years is eternal; or if it is thus to be thought of, they cease to reign when the thousand years are finished. But I will put forward what my capacity enables me to judge. The tenfold number signifies the decalogue, and the hundredfold sets forth the crown of virginity: for he who shall have kept the undertaking of virginity completely, and shall have faithfully fulfilled the precepts of the decalogue, and shall have destroyed the untrained nature or impure thoughts within the retirement of the heart, that they may not rule over him, this is the true priest of Christ, and accomplishing the millenary number thoroughly, is thought to reign with Christ; and truly in his case the devil is bound. But he who is entangled in the vices and the dogmas of heretics, in his case the devil is loosed. But that it says that when the thousand years are finished he is loosed, so the number of the perfect saints being completed, in whom there is the glory of virginity in body and mind, by the approaching advent of the kingdom of the hateful one, many, seduced by that love of earthly things, shall be overthrown, and together with him shall enter the lake of fire."), _c('a', {
    attrs: {
      "id": "fn138"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn138"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("The second commentary to be considered comes from (the Venerable) Bede (ca. 672-735)."), _c('a', {
    attrs: {
      "id": "fn139"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn139"
    }
  }, [_vm._v("139")])]), _vm._v(" Bede’s work, which is a running commentary on every verse in Revelation, is over 40,000 words long. Several aspects of this volume merit comment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As far as can be determined, Bede is the first interpreter to offer a seven-part structure for Revelation. His view of the structure is roughly as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb4"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("Preface 1:1-8")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("1. 1:9–3:22")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("2. 4:1–7:17")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("3. 8:1–11:18")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("4. 11:19–15:8")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("5. 16:1-21")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("6. 17:1–18:24")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1a"
  }, [_vm._v("7. 19:1–22:21")])]), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("In the commentary itself, however, Bede’s work takes the form of three books (Book 1: 1–8; Book 2: 9–14; Book 3: 15–22). In a letter he explains this move by saying that three short books relieve the mind of the readers better than seven. Bede is clearly indebted to interpreters before him. There are places where his interpretative decisions mirror those of Victorinus. He not only cites the interpretive rules of Tyconius in his letter to Eusebius, but he also quotes Tyconius some ten times in the body of the commentary. Generally, Bede sees recapitulation at work in Revelation, specifically mentioning that the story is recapitulated at several points (4:1; 8:1; 9:20; 11:18; 20:1). Like Victorinus before him, much of the interpretive approach could be described as spiritual or even allegorical in nature. He offers some “philological” evidence in his exposition, as for example when he gives a definition of the meaning of the names of six of the seven churches in Rev 2–3. The four living creatures are the Evangelists, and when they preach, everyone falls down. The book in the hand of the one who sits on the throne, described in chapter 5, is the Bible; the writing on the outside is the OT, while the writing on the inside is the NT. At a number of points Bede sees the symbols of Revelation as pointing to the heretics with which the church is confronted. They are identified as the pale horse in Rev 6 and one of the trumpets in Rev 8. There are extensive explanations offered for the order and significance of the twelve tribes of chapter 7 and the jewels found in the description of the New Jerusalem in chapter 21. The theophanic element of lightning is identified on several occasions as referring to the working of miracles. Those playing harps are those who have been crucified. Mention of the sea of glass refers to baptism, as does mention of the first resurrection in 20:5. Apparently influenced by Tyconius and Augustine, Bede interprets the thousand-year reign as the present time, that is, what remains of the sixth day, at the end of which Satan is loosed for 3½ years. The liars mentioned in 21:8 are those who claim to be Jews but are not.")]), _c('a', {
    attrs: {
      "id": "fn140"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn140"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("The third commentary to be discussed is the "), _c('i', [_vm._v("Expositio in Apocalypsim,")])]), _c('a', {
    attrs: {
      "id": "fn141"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn141"
    }
  }, [_vm._v("141")])]), _vm._v(" by the medieval abbot Joachim of Fiore (ca. 1135-1202). This commentary, which is considered the abbot’s greatest work, incorporates earlier writing on Revelation entitled the "), _c('i', [_vm._v("Enchiridion super Apocalypsim.")]), _vm._v(" Following an introduction, the commentary is divided into eight books, each devoted to a section of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("Book 1"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("1:1–3:22 — Letters to the Seven Churches")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 2"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("4:1–8:1 — The Opening of the Seven Seals")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 3"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("8:2–11:18 — The Seven Trumpet Blasts")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 4"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("11:19–14:20 — The Two Beasts")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 5"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("15:1–16:17 — The Seven Bowls")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 6"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("16:18–19:21 — The Destruction of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 7"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("20:1-10 — The Millennium")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Book 8"), _c('span', {
    staticClass: "space1b"
  }), _vm._v("20:11–22:21 — The Heavenly Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("These eight parts of Revelation correspond to the seven special times (eras) of the church, followed by the eighth, which corresponds to the glorification of the heavenly Jerusalem."), _c('a', {
    attrs: {
      "id": "fn142"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn142"
    }
  }, [_vm._v("142")])]), _vm._v(" Crucial to Joachim’s interpretation is his understanding of redemptive history as being divided into three eras or statuses, namely, the era of the Father, the era of the Son, and the era of the Holy Spirit. While these eras have distinct points at which they begin and end, they also overlap with one another. Joachim, who produced a number of works entitled "), _c('i', [_vm._v("Liber Figurarum")]), _vm._v(" (“Book of Figures”), by which he taught theological truths, conveyed this reality as three successive circles that overlap with one another. They are arranged in such a way, however, that all three converge at the centermost part, signifying the unity of the Father, Son, and Holy Spirit. The age of the Father can be traced from Adam until Christ’s first advent, the age of the Son begins there, and the age of the Spirit is still to come. Within these three eras the seven ages of redemptive history may be fitted. The first five (Adam, Noah, Abraham, David, and Babylonian Exile) occurred in the age of the Father, the sixth (John the Baptist) in the age of the Son, with the seventh awaiting the beginning of the era of the Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Part of Joachim’s contribution is the employment of historical referents in the interpretation of Revelation. For example, in his discussion of the beast with seven heads found in Rev 12 and following, Joachim offers these identifications set out in the chart that follows:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('b', [_vm._v("Head")])])]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_c('b', [_vm._v("Person")])]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_c('b', [_vm._v("Persecution by")])]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_c('b', [_vm._v("Time period reflected")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("1.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Herod")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Jews")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Apostles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("2.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Nero")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Pagans")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Martyrs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("3.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Constantius")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Heretics")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Doctors")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("4.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Muhammad")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Saracens")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Virgins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("5.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Mesomoth")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Son of Babylon")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Conventuals")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("6.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Saladin")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Spiritual men")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("In Joachim’s time")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-centera"
  }, [_vm._v("7.")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Gog")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("Second antichrist")]), _vm._v(" "), _c('td', {
    staticClass: "table-lefta"
  }, [_vm._v("End of time")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("As the chart indicates, these historical identifications enable the reader to make their way through redemptive history. The mention of Joachim’s contemporary Saladin (1138-93) as the sixth head of the beast reveals something of the eschatological expectancy of Joachim’s thinking, for Saladin was the Muslim leader who recaptured Jerusalem from the Crusaders. From Joachim’s perspective, the seventh head could appear at any time, signaling the end of time and the beginning of the age of the Spirit in earnest. Challenging the amillennial views of interpreters like Tyconius and Augustine, Joachim’s work fueled the fire for millennial expectation in numerous later interpreters."), _c('a', {
    attrs: {
      "id": "fn143"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn143"
    }
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A final commentary to be mentioned in this survey is by Allan A. Boesak."), _c('a', {
    attrs: {
      "id": "fn144"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn144"
    }
  }, [_vm._v("144")])]), _vm._v(" Writing during the time of apartheid in South Africa, Boesak combines an analysis of the text that focuses on the message of the book for John, as well as its contemporary significance. Following an extensive introductory chapter, the rest of the book is divided into seven chapters, entitled:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("The Blessing")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Scroll")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Seven Seals Opened")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Woman and the Dragon")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Beast from the Sea and the Beast from the Earth")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The Fall of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The End and the Beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Boesak sees Revelation as underground protest literature written within the context of a persecuted church. Bringing considerable attention to historical issues of introduction, Boesak argues that ultimately such issues are of secondary importance for readers of the book. For example, though he will argue vigorously for a date of composition sometime during the reign of Domitian, in comparison to the context of the “oppressed” reader, this point is relatively inconsequential. He comments:")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("The arguments around the different hypotheses seem to lead always to an effort to establish the truth about judging the "), _c('i', [_vm._v("degree")]), _vm._v(" of oppression that was meted out by one or another emperor. Whether it was Nero or Domitian or even Galba (as John A. T. Robinson suggests) is ultimately of secondary importance. To the suffering people of God it did not really matter who they suffered under. What mattered is that they suffered. . . . It is the fact that the weak and the destitute remained oppressed which provides the framework for understanding and interpreting history.")]), _c('a', {
    attrs: {
      "id": "fn145"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn145"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Describing his work as “biblical exegesis from the underside,” Boesak writes specifically with the black South African church in mind. He notes:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("For people who face situations like these, the Apocalypse is an exciting, inspiring, and marvellous book. It is a book which, in our sociopolitical situation, is a constant call to conversion and change. It is prophetic, historical, contemporary. But we shall have to learn to read it differently. We shall have to do away with those sterile escape mechanisms and dead-end arguments about numbers and symbols and signs by which the real message is so often paralyzed."), _c('a', {
    attrs: {
      "id": "fn146"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn146"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Boesak’s reading is one in which the text of Revelation, its first-century context, and the context of the black South African church interact on an almost constant basis. Examples of the power of this interaction abound, as the following citations reveal. Note his comments on the meaning of the song in Rev 5:12:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("On a Sunday afternoon young black Christians pick up this ancient song and make of it a new song as they dance around a police vehicle just after a student has been arrested at our church service. . . . In translation it goes something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("“It is broken, the power of Satan is broken!")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("We have disappointed Satan, his power is broken.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Alleluia.”")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb3a"
  }, [_vm._v("As we sing, the song is picked up by others. The police somewhat confused, somewhat bewildered, somewhat scared, release our friend. Others join us as we march, singing and dancing, back into the church. This is a new song, a freedom song, and the power of it, the sheer joy of it, the amazing truth in it captivate and inspire thousands upon thousands throughout South Africa. For although the seals of the scroll must still be opened, the scroll is not in the hands of Caesar but in the hands of the Lamb. And we will sing this new song until “every creature in heaven and on earth and under the earth and in the sea, and all therein,” will say (5:13):")])]), _c('p', {
    staticClass: "QuoteSb1Sb"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("“To him who sits on the throne and to the Lamb be blessing and honour and glory and might for ever and ever!”")]), _c('a', {
    attrs: {
      "id": "fn147"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn147"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Boesak’s interpretation of the “souls under the altar” in 6:9-10 is no less insightful.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("The martyrs are dead, but their witness is still alive. Their voices can still be heard; they still inspire the church. They remind the church of what it means to be faithful to Jesus the Messiah, of the price one must pay for testimony to the one true God. They remind the church also of the true character of the powers of this world. The church must not forget who and what it is facing."), _c('a', {
    attrs: {
      "id": "fn148"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn148"
    }
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("To interpreters who are repelled by the vengeful nature of the martyrs’ prayer, Boesak responds:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("People who do not know what oppression and suffering is react strangely to the language of the Bible. The truth is that God "), _c('i', [_vm._v("is")]), _vm._v(" the God of the poor and the oppressed. . . . The oppressed do not see any dichotomy between God’s love and God’s justice. Why is there this division between the God of the Old Testament and the God of Jesus? Why, on this point, does white Western Christianity go back to the heresy of Marcion?"), _c('a', {
    attrs: {
      "id": "fn149"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn149"
    }
  }, [_vm._v("149")])])]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("On the identity of the number of the beast, Boesak says:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("For the key here is not who the beast is; the church knows that. Neither is the key whether we begin counting from D. F. Malan or H. F. Verwoerd or P. W. Botha, from 1910 or from 1948. The key here is the understanding of the mystery: this beast, this powerful merciless, violent beast, was and is not and goes to perdition. . . . It has no life and no future. It comes from hell and goes to hell.")]), _c('a', {
    attrs: {
      "id": "fn150"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn150"
    }
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("On the prophecy about the fall of Rome and, by extension, the fall of the apartheid regime, he notes:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("We must remember that as John writes there is no sign whatsoever of the imminent fall of Rome. He speaks like an Old Testament prophet. The vision is so clear, God’s decision so certain, that for all intents and purposes it has already happened. Rome still stands, but John already can hear and see the rumblings and ripples of the mighty earthquake that will hit the city. He knows the end of Rome is near. . . . Rome may still have power, but John knows that we are seeing the beast’s final convulsions."), _c('a', {
    attrs: {
      "id": "fn151"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn151"
    }
  }, [_vm._v("151")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("A final example comes from his stinging words on the need for a new heaven and new earth:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb1"
  }, [_vm._v("How well should we understand this, we people of the twentieth century. We saw the heavens polluted by the foul and vile smoke from the factories, made hopelessly inhabitable for the birds of the sky in the name of progress. We know about “missiles carving highways of death through the stratosphere.” . . . Can the heavens ever be clean again after Hiroshima and Nagasaki? Can the heavens ever be purified of the stench of gas ovens, burned-out villages in Asia, or utterly destroyed Palestinian camps in Lebanon? And the vilest stench of all: those powerful and mighty men in top hats, sashes, and uniforms who threaten and maim, kill and destroy, and then go to prayer breakfast and call upon the name of God. . . . No, John is so right — there must be a new earth and new heaven."), _c('a', {
    attrs: {
      "id": "fn152"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn152"
    }
  }, [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Though Boesak would have his own temptations and struggles with the seduction of the beast, his commentary has few rivals among those seeking to bring one’s context to bear on the interpretation of Revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "imageL1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". The most extensive study of the structure of Revelation is that of R. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy: Studies on the Book of Revelation")]), _vm._v(" (Edinburgh: T&T Clark, 1993), 1-37. As will be apparent, much of what follows in this section is informed by this excellent essay. For a critique of Bauckham’s work, cf. P. Prigent, "), _c('i', [_vm._v("L’Apocalypse de Saint Jean")]), _vm._v(" (CNT 14; Geneva: Labor & Fides, 2000), 71-74. For additional discussions on the structure of Revelation, cf. F. D. Mazzaferri, "), _c('i', [_vm._v("The Genre of the Book of Revelation from a Source-Critical Perspective")]), _vm._v(" (Berlin: Walter de Gruyter, 1989), 330-65, and D. E. Aune, "), _c('i', [_vm._v("Revelation 1–5")]), _vm._v(" (WBC 52A; Dallas: Word, 1997), xc-cv.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Reference is also made to seven thunders (10:3-4), but unlike the others mentioned, they are sealed up and not written down.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". J. L. Resseguie, "), _c('i', [_vm._v("The Revelation of John: A Narrative Commentary")]), _vm._v(" (Grand Rapids: Baker, 2009), 53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". For this designation, cf. D. L. Barr, “The Apocalypse of John as Oral Enactment,” "), _c('i', [_vm._v("Int")]), _vm._v(" 40 (1986): 243-56.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". The following observations are based in large part on the work of Barr, “The Apocalypse of John as Oral Enactment,” and S. S. Smalley, "), _c('i', [_vm._v("Thunder and Love: John’s Revelation and John’s Community")]), _vm._v(" (Milton Keynes, UK: Word, 1994), cf. esp. 103-10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". In addition to the work of Smalley, cf. E. Dansk, "), _c('i', [_vm._v("The Drama of the Apocalypse")]), _vm._v(" (London: T. Fisher Unwin, 1894); E. W. Benson, "), _c('i', [_vm._v("The Apocalypse: An Introductory Study of the Revelation of St John the Divine")]), _vm._v(" (New York: Macmillan, 1900), 4-41; R. R. Brewer, “The Influence of Greek Drama on the Apocalypse of John,” "), _c('i', [_vm._v("ATR")]), _vm._v(" 18 (1935-36): 74-92; and J. W. Bowman, “The Revelation to John: Its Dramatic Structure and Message,” "), _c('i', [_vm._v("Int")]), _vm._v(" 9 (1955): 436-53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". On this proposal, cf. R. Bauckham, "), _c('i', [_vm._v("The Theology of the Book of Revelation")]), _vm._v(" (Cambridge: Cambridge University Press, 1993), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". On the liturgical context of Revelation, cf. J.-P. Ruiz, "), _c('i', [_vm._v("Ezekiel in the Apocalypse: The Transformation of Prophetic Language in Revelation 16,17–19,10")]), _vm._v(" (EUSST 23; Frankfurt: Lang, 1989), 184-89.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". For this idea, cf. R. W. Wall, "), _c('i', [_vm._v("Revelation")]), _vm._v(" (NIBC, NTS 18; Peabody, MA: Hendrickson, 1991), 13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Another possible prophetic utterance from the risen Jesus is found in 13:9-10, while 2:21 is sometimes taken as reference to an earlier (unrecorded) prophetic word given by John.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". On this issue, cf. esp. Mazzaferri, "), _c('i', [_vm._v("The Genre of the Book of Revelation from a Source-Critical Perspective,")]), _vm._v(" 259-378.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". On the issue of prophetic consciousness, cf. the very helpful works by A. J. Heschel, "), _c('i', [_vm._v("The Prophets")]), _vm._v(" (2 vols.; Peabody, MA: Hendrickson, 2003), and R. D. Moore, “The Prophetic Calling: An Old Testament Profile and Its Relevance for Today,” "), _c('i', [_vm._v("JEPTA")]), _vm._v(" 24 (2004): 16-29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Bauckham, "), _c('i', [_vm._v("The Theology of the Book of Revelation,")]), _vm._v(" 5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Cf. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Cf., for example, J. Sweet, "), _c('i', [_vm._v("Revelation")]), _vm._v(" (London: SCM Press, 1990), 1-5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". For a similar point, cf. G. Linton, “Reading the Apocalypse as an Apocalypse,” in "), _c('i', [_vm._v("SBL Seminar Papers")]), _vm._v(" (Atlanta: Scholars Press, 1991), 174-82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". Perhaps the most widely used set of criteria for defining the genre are those proposed by J. J. Collins, “Toward the Morphology of a Genre,” "), _c('i', [_vm._v("Semeia")]), _vm._v(" 14 (1979): 1-20. Cf. also the perceptive comments of Linton, “Reading the Apocalypse as an Apocalypse,” 178-85.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18"
    }
  }, [_vm._v("18")]), _vm._v(". E. Schüssler Fiorenza, "), _c('i', [_vm._v("Revelation: Vision of a Just World")]), _vm._v(" (Minneapolis: Fortress Press, 1991), 23, notes, “Revelation employs stock images, conventional "), _c('i', [_vm._v("topoi")]), _vm._v(" or places, scriptural figures, and proofs, as well as literary techniques developed in apocalyptic literature.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Bauckham, "), _c('i', [_vm._v("The Theology of the Book of Revelation,")]), _vm._v(" 7-9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20"
    }
  }, [_vm._v("20")]), _vm._v(". Schüssler Fiorenza, "), _c('i', [_vm._v("Revelation: Vision of a Just World,")]), _vm._v(" 24-25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21"
    }
  }, [_vm._v("21")]), _vm._v(". The other possible exception to this practice also comes from a Christian writer, the Shepherd of Hermas.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22"
    }
  }, [_vm._v("22")]), _vm._v(". Bauckham, "), _c('i', [_vm._v("The Theology of the Book of Revelation,")]), _vm._v(" 9-12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23"
    }
  }, [_vm._v("23")]), _vm._v(". G. K. Beale, "), _c('i', [_vm._v("The Book of Revelation: A Commentary on the Greek Text")]), _vm._v(" (NIGNT; Grand Rapids: Eerdmans, 1999), 37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 38-91. On the relationship between prophecy and apocalyptic, cf. the helpful comments by R. D. Moore, “Joel” (manuscript), 8-10, to appear in "), _c('i', [_vm._v("The Book of the Twelve")]), _vm._v(" (ed. J. C. Thomas; Blandford Forum, UK: Deo Publishing).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25"
    }
  }, [_vm._v("25")]), _vm._v(". Contra Beale, "), _c('i', [_vm._v("The Book of Revelation,")]), _vm._v(" 76-99.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26"
    }
  }, [_vm._v("26")]), _vm._v(". Contra E. Schüssler Fiorenza, "), _c('i', [_vm._v("Revelation: Justice and Judgment")]), _vm._v(" (Philadelphia: Fortress Press, 1985), 135.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27"
    }
  }, [_vm._v("27")]), _vm._v(". Cf. the helpful comments by F. J. Murphy, "), _c('i', [_vm._v("Fallen Is Babylon: The Revelation to John")]), _vm._v(" (Harrisburg, PA: Trinity Press International, 1998), 28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28"
    }
  }, [_vm._v("28")]), _vm._v(". S. Moyise, "), _c('i', [_vm._v("The Old Testament in the Book of Revelation")]), _vm._v(" (JSNTS 115; Sheffield: Sheffield Academic Press, 1995), 19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29"
    }
  }, [_vm._v("29")]), _vm._v(". R. W. Wall and E. E. Lemcio, "), _c('i', [_vm._v("The New Testament as Canon: A Reader in Canonical Criticism")]), _vm._v(" (JSNTS 76; Sheffield: JSOT Press, 1992), 276, observe, “Today, there are still some non-Chalcedon (i.e., Nestorian) Christian communions who reject the canonicity of Revelation and follow the Peshitta, an ancient Syriac version of the Bible that excludes Revelation along with 2 Peter, 2–3 John, and Jude.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30"
    }
  }, [_vm._v("30")]), _vm._v(". B. M. Metzger, "), _c('i', [_vm._v("The Canon of the New Testament: Its Origin, Development, and Significance")]), _vm._v(" (Oxford: Clarendon Press, 1987), 295.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31"
    }
  }, [_vm._v("31")]), _vm._v(". Metzger, "), _c('i', [_vm._v("The Canon of the New Testament,")]), _vm._v(" 295.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32"
    }
  }, [_vm._v("32")]), _vm._v(". A suggestion made by J. Painter in private conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33"
    }
  }, [_vm._v("33")]), _vm._v(". Sweet, "), _c('i', [_vm._v("Revelation,")]), _vm._v(" 50-52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Cf. J. C. Thomas, "), _c('i', [_vm._v("The Spirit of the New Testament")]), _vm._v(" (Leiderdorp, Neth.: Deo Publishing, 2004), 157-74.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35"
    }
  }, [_vm._v("35")]), _vm._v(". Cf. J. C. Thomas, "), _c('i', [_vm._v("1 John, 2 John, 3 John")]), _vm._v(" (London: T&T Clark, 2004), 13-14, 123-41, 197-214, 249-64.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36"
    }
  }, [_vm._v("36")]), _vm._v(". Cf. R. C. Waddell, "), _c('i', [_vm._v("The Spirit of the Book of Revelation")]), _vm._v(" (JPTS 30; Blandford Forum, UK: Deo Publishing, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37"
    }
  }, [_vm._v("37")]), _vm._v(". For some of these ideas about Revelation’s canonical function on the level of metanarrative, cf. R. Wall, "), _c('i', [_vm._v("The New Testament as Canon,")]), _vm._v(" 280-82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38"
    }
  }, [_vm._v("38")]), _vm._v(". Cf. the work of W. Ramsay ("), _c('i', [_vm._v("The Seven Letters to the Seven Churches of Asia and Their Place in the Plan of the Apocalypse")]), _vm._v(" [London: Hodder & Stoughton, 1904], 183-96), which has influenced a number of scholars on this topic.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39"
    }
  }, [_vm._v("39")]), _vm._v(". J. R. Michaels, "), _c('i', [_vm._v("Interpreting the Book of Revelation")]), _vm._v(" (Grand Rapids: Baker, 1992), 35-36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40"
    }
  }, [_vm._v("40")]), _vm._v(". According to R. E. Brown, "), _c('i', [_vm._v("The Epistles of John")]), _vm._v(" (Garden City, NY: Doubleday, 1982), 21, not even Luke and Acts are as similar to one another as are 1 John and the Fourth Gospel!")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41"
    }
  }, [_vm._v("41")]), _vm._v(". For my thoughts on this issue, cf. Thomas, "), _c('i', [_vm._v("1 John, 2 John, 3 John,")]), _vm._v(" 4-10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42"
    }
  }, [_vm._v("42")]), _vm._v(". The most helpful work on this topic is M. Hengel’s "), _c('i', [_vm._v("The Johannine Question")]), _vm._v(" (London: SCM Press; Philadelphia: Trinity Press International, 1989). Cf. also his more extensive treatment "), _c('i', [_vm._v("Die johanneische Frage: Ein Lösungversuch")]), _vm._v(" (Tübingen: J. C. B. Mohr [Paul Siebeck], 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43"
    }
  }, [_vm._v("43")]), _vm._v(". Cf. esp. the carefully detailed analysis by J. Frey, “Erwägungen zum Verhältnis der Johannesapokalypse zu den übringen Schriften des Corpus Johanneum,” in "), _c('i', [_vm._v("Die johanneische Frage,")]), _vm._v(" by Hengel, with J. Frey, 326-429. Prigent ("), _c('i', [_vm._v("L’Apocalypse de Saint Jean,")]), _vm._v(" 26) describes Frey’s work as follows: “L’étude, remarquablement documentée, bénéficie d’instruments de travail, notamment d’ordre statistique, qui manquaient à ses grands devanciers. Ses résultats sont donc plus précis, plus objectifs et donc plus fiables.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44"
    }
  }, [_vm._v("44")]), _vm._v(". Y. Simoens, "), _c('i', [_vm._v("Apocalypse de Jean: Apocalypse de Jésus Christ")]), _vm._v(" (Paris: Éditions Facultés Jésuites de Paris, 2008), xii, and S. S. Smalley, "), _c('i', [_vm._v("The Revelation to John")]), _vm._v(" (Downers Grove, IL: Inter-Varsity Press, 2005), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45"
    }
  }, [_vm._v("45")]), _vm._v(". This important Johannine theme is also found in 1 John 1:2, 5:6-12, and 3 John 3, 6, 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46"
    }
  }, [_vm._v("46")]), _vm._v(". On the significance of titles in NT documents, cf. M. Hengel, "), _c('i', [_vm._v("Studies in the Gospel of Mark")]), _vm._v(" (trans. J. Bowden; Philadelphia: Fortress Press, 1985), 64-84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47"
    }
  }, [_vm._v("47")]), _vm._v(". Cf. Ruiz ("), _c('i', [_vm._v("Ezekiel in the Apocalypse,")]), _vm._v(" 195-99), who goes on to suggest that several other verses (13:9-10, 18; 17:9, as well as 1:20; 10:7; 17:5, 7) are also evidence for this phenomenon (pp. 200-214).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48"
    }
  }, [_vm._v("48")]), _vm._v(". Cf. esp. the helpful discussion by D. Hill, "), _c('i', [_vm._v("New Testament Prophecy")]), _vm._v(" (Atlanta: John Knox Press, 1979), 87-93, and P. Poucouta, “La mission prophétique de l’église dans l’Apocalypse johannique,” "), _c('i', [_vm._v("NRT")]), _vm._v(" 110 (1988): 38-57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49"
    }
  }, [_vm._v("49")]), _vm._v(". The reference to those “not defiled by women” in 14:4 is taken up in detail in the commentary below.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50"
    }
  }, [_vm._v("50")]), _vm._v(". Cf. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 384-452.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51"
    }
  }, [_vm._v("51")]), _vm._v(". Cf. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 338-83.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52"
    }
  }, [_vm._v("52")]), _vm._v(". This chart is a slight modification of one by D. E. Aune, “Notes to ‘Revelation to John (Apocalypse),’ ” in "), _c('i', [_vm._v("Harper Collins Study Bible")]), _vm._v(" (New York: HarperCollins, 1993), 2330, also cited by Murphy, "), _c('i', [_vm._v("Fallen Is Babylon,")]), _vm._v(" 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53"
    }
  }, [_vm._v("53")]), _vm._v(". Beale, "), _c('i', [_vm._v("The Book of Revelation,")]), _vm._v(" 21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54"
    }
  }, [_vm._v("54")]), _vm._v(". Beale, "), _c('i', [_vm._v("The Book of Revelation,")]), _vm._v(" 18-19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn55"
    }
  }, [_vm._v("55")]), _vm._v(". On this whole question, cf. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 407-41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn56"
    }
  }, [_vm._v("56")]), _vm._v(". Aune, "), _c('i', [_vm._v("Revelation 1–5,")]), _vm._v(" lxiv.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn57"
    }
  }, [_vm._v("57")]), _vm._v(". Aune, "), _c('i', [_vm._v("Revelation 1–5,")]), _vm._v(" lxvi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn58"
    }
  }, [_vm._v("58")]), _vm._v(". Cited according to the translation of J. Jackson, "), _c('i', [_vm._v("Tacitus,")]), _vm._v(" vol. 4 (London: Heinemann, 1962), 283-85.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn59"
    }
  }, [_vm._v("59")]), _vm._v(". Cited according to the translation of J. C. Rolfe, "), _c('i', [_vm._v("Suetonius,")]), _vm._v(" vol. 2 (London: Heinemann, 1965), 111.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn60"
    }
  }, [_vm._v("60")]), _vm._v(". Cf. Philostratus, "), _c('i', [_vm._v("Life of Apollonius")]), _vm._v(" 4.38, and perhaps the "), _c('i', [_vm._v("Sibylline Oracles")]), _vm._v(" 5.343.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn61"
    }
  }, [_vm._v("61")]), _vm._v(". Cited according to the translation of K. Lake, "), _c('i', [_vm._v("Eusebius,")]), _vm._v(" vol. 1 (London: Heinemann, 1926), 391. Cf. also Melito Fragment 1 in "), _c('i', [_vm._v("Melito of Sardis: On Pascha and Fragments")]), _vm._v(" (ed. and trans. S. G. Hall; Oxford: Clarendon Press, 1979), 65.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn62"
    }
  }, [_vm._v("62")]), _vm._v(". Cited according to the translation in "), _c('i', [_vm._v("The Writings of Tertullian,")]), _vm._v(" vol. 1 (ed. A. Roberts and J. Donaldson; Edinburgh: T&T Clark, 1869), 64. This passage from Tertullian is also cited by Eusebius ("), _c('i', [_vm._v("Ecclesiastical History")]), _vm._v(" 3.19-20).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn63"
    }
  }, [_vm._v("63")]), _vm._v(". Cf. C. J. Hemer, "), _c('i', [_vm._v("The Letters to the Seven Churches of Asia in Their Local Settings")]), _vm._v(" (JSNTS 11; Sheffield: JSOT Press, 1986), 2-5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn64"
    }
  }, [_vm._v("64")]), _vm._v(". Cited according to the translation found in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" vol. 1 (ed. A. Roberts and J. Donaldson; Grand Rapids: Eerdmans, 1989), 240.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn65"
    }
  }, [_vm._v("65")]), _vm._v(". Cited according to the translation of M. W. Holmes, "), _c('i', [_vm._v("The Apostolic Fathers: Greek Texts and English Translations")]), _vm._v(" (Grand Rapids: Baker, 1992), 577.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn66"
    }
  }, [_vm._v("66")]), _vm._v(". Cited according to the translation of Lake, "), _c('i', [_vm._v("Eusebius: The Ecclesiastical History,")]), _vm._v(" 1:243 (3.23.5-6).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn67"
    }
  }, [_vm._v("67")]), _vm._v(". Cited according to the translation found in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" 1:559-60. For the critical questions surrounding the meaning of this quote, cf. Aune, "), _c('i', [_vm._v("Revelation 1–5,")]), _vm._v(" lviii-lix.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn68"
    }
  }, [_vm._v("68")]), _vm._v(". Beale, "), _c('i', [_vm._v("The Book of Revelation,")]), _vm._v(" 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn69"
    }
  }, [_vm._v("69")]), _vm._v(". Origen, "), _c('i', [_vm._v("Commentary on John")]), _vm._v(" 10.35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn70"
    }
  }, [_vm._v("70")]), _vm._v(". On the significance of the place of 1:10 in the narrative of Revelation for this understanding of “the Day of the Lord” and other aspects of the question, cf. A. Bacchiocchi, "), _c('i', [_vm._v("From Sabbath to Sunday: An Historical Investigation into the Rise of Sunday Observance in Early Christianity")]), _vm._v(" (Rome: Pontifical Gregorian University Press, 1977), 123-30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn71"
    }
  }, [_vm._v("71")]), _vm._v(". At this point it might prove beneficial to consider this very phenomenon within the prophetic literature of the OT, for such a practice is not wholly without precedent. The typical way by which the date of an OT prophetic book is revealed is by means of the phrase “the word of the Lord came to [a certain prophet] in the days of [a certain] king[s]” (cf. Jer 1:2-3; Ezek 2:3; Hos 1:1; Amos 1:1; Mic 1:1; Zeph 1:1; Hag 1:1; Zech 1:1). However, on occasion, a book does not contain this phrase and, consequently, does not make reference to the reign of a certain king. With the book of Joel it appears that this lack of an internal indicator of the book’s date is an intentional device to draw attention to “the day of the Lord.” Cf. the perceptive comments of R. D. Moore (“Joel” [manuscript], 6, to appear in "), _c('i', [_vm._v("The Book of the Twelve")]), _vm._v("), who notes:")]), _vm._v(" "), _c('p', {
    staticClass: "foota"
  }, [_vm._v("My alternative suggestion is that Joel intentionally refrains from assigning a date, not because he wants to establish a “dehistoricized” liturgy relevant for all time, but rather because he sees the Day of the Lord eclipsing all of time and all of our days to the point of rendering them irrelevant — irrelevant enough to be left unspecified. Refusing to tell us in the first verse, as we would expect, that the word of the LORD came to Joel "), _c('i', [_vm._v("“in the days of (a certain) king,”")]), _vm._v(" Joel seems deliberately to accentuate this omission in the second verse by prefacing the prophetic word with the question, “Has anything like this happened "), _c('i', [_vm._v("in your days or the days of your father?")]), _vm._v("” . . . This day is so much bigger than the big days (viz., royal coronations) by which time has previously been calculated, that it blows away the entire dating system to become for Joel the new referent point for all future generations (cf. 1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "footb"
  }, [_vm._v("Given Revelation’s self-conscious identification with the prophetic literature, perhaps a similar phenomenon may be at work here.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn72"
    }
  }, [_vm._v("72")]), _vm._v(". On this whole matter, cf. Mazzaferri, "), _c('i', [_vm._v("The Genre of the Book of Revelation from a Source-Critical Perspective,")]), _vm._v(" 264-96.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn73"
    }
  }, [_vm._v("73")]), _vm._v(". Cf. Mazzaferri, "), _c('i', [_vm._v("The Genre of the Book of Revelation from a Source-Critical Perspective,")]), _vm._v(" 296-317.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn74"
    }
  }, [_vm._v("74")]), _vm._v(". Cf. Mazzaferri, "), _c('i', [_vm._v("The Genre of the Book of Revelation from a Source-Critical Perspective,")]), _vm._v(" 317-30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn75"
    }
  }, [_vm._v("75")]), _vm._v(". Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn76"
    }
  }, [_vm._v("76")]), _vm._v(". On the extent of the activity of the prophetic community, cf. Bauckham, "), _c('i', [_vm._v("The Climax of Prophecy,")]), _vm._v(" 83-91. The idea that Revelation was written down some time after it was experienced is found as early as Victorinus, "), _c('i', [_vm._v("Commentary on the Apocalypse of the Blessed John,")]), _vm._v(" in his comments on 10:11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn77"
    }
  }, [_vm._v("77")]), _vm._v(". Contra R. K. MacKenzie, "), _c('i', [_vm._v("The Author of the Apocalypse: A Review of the Prevailing Hypothesis of Jewish-Christian Authorship,")]), _vm._v(" (MBPS 51; Lewiston, NY: Edwin Mellen Press, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn78"
    }
  }, [_vm._v("78")]), _vm._v(". On this aspect of John’s identity, cf. M. Hengel, "), _c('i', [_vm._v("The Johannine Question,")]), _vm._v(" 125-26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn79"
    }
  }, [_vm._v("79")]), _vm._v(". Note Waddell’s perceptive criticism of one such approach in "), _c('i', [_vm._v("The Spirit of the Book of Revelation,")]), _vm._v(" 85. “In conclusion, I have a few concerns with Beale’s hermeneutics. Although I highly value Beale’s detailed analysis of John’s use of the Old Testament in the Apocalypse, at the end of the day, as a Pentecostal, I find it inadequate. He leaves insufficient room for John to be recording an actual vision as opposed to solely exegeting Scripture. When I read the text, I assume John is interpreting and relaying an experience in the Spirit, albeit not void of Old Testament allusions. The Apocalypse ought not be reduced solely to a contextually sensitive exegesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn80"
    }
  }, [_vm._v("80")]), _vm._v(". On this analogy, cf. also S. Moyise, "), _c('i', [_vm._v("The Old Testament in the Book of Revelation,")]), _vm._v(" 40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn81"
    }
  }, [_vm._v("81")]), _vm._v(". The most comprehensive study on this topic to date is Frey, “Erwägungen zum Verhältnis der Johannesapokalypse zu den übrigen Schriften des Corpus Johanneum,” 326-429. Cf. also the still influential work of R. H. Charles, "), _c('i', [_vm._v("The Revelation of St. John,")]), _vm._v(" vol. 1 (ICC; Edinburgh: T&T Clark, 1920), xxix-xxxi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn82"
    }
  }, [_vm._v("82")]), _vm._v(". F. J. A. Hort, "), _c('i', [_vm._v("The Apocalypse of St. John,")]), _vm._v(" vol. 1 (London: Macmillan, 1908), xxxviii; C. G. Ozanne, “The Language of the Apocalypse,” "), _c('i', [_vm._v("TynB")]), _vm._v(" 16 (1965): 3-9; Ruiz, "), _c('i', [_vm._v("Ezekiel in the Apocalypse,")]), _vm._v(" 224, 518, 529.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn83"
    }
  }, [_vm._v("83")]), _vm._v(". A. D. Callahan, “The Language of the Apocalypse,” "), _c('i', [_vm._v("HTR")]), _vm._v(" 88 (1995): 453-70.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn84"
    }
  }, [_vm._v("84")]), _vm._v(". I am indebted to my colleague R. D. Moore for this observation. Cf. also G. R. Osborne, "), _c('i', [_vm._v("Revelation")]), _vm._v(" (ECNT; Grand Rapids: Baker, 2002), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn85"
    }
  }, [_vm._v("85")]), _vm._v(". In any case, Revelation’s grammatical style is not without theological significance. Cf. Resseguie, "), _c('i', [_vm._v("The Revelation of John,")]), _vm._v(" 49-53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn86"
    }
  }, [_vm._v("86")]), _vm._v(". Beale, "), _c('i', [_vm._v("The Book of Revelation,")]), _vm._v(" 35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn87"
    }
  }, [_vm._v("87")]), _vm._v(". As G. B. Caird ("), _c('i', [_vm._v("The Revelation of Saint John")]), _vm._v(" [London: A&C Black, 1966], 5) observes, “Because a man writes in Hebraic Greek, it does not inevitably follow that this is the only Greek he is capable of writing. He may have adopted this style for quite deliberate reasons of his own, as Luke appears to have.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn88"
    }
  }, [_vm._v("88")]), _vm._v(". Cited according to the translation of K. Lake, "), _c('i', [_vm._v("Eusebius: The Ecclesiastical History,")]), _vm._v(" vol. 2 (London: Heinemann, 1932), 199.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn89"
    }
  }, [_vm._v("89")]), _vm._v(". Cited according to the translation of K. Lake, "), _c('i', [_vm._v("Eusebius: The Ecclesiastical History,")]), _vm._v(" 2:209.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn90"
    }
  }, [_vm._v("90")]), _vm._v(". Cf. the relevant discussion in Thomas, "), _c('i', [_vm._v("1 John, 2 John, 3 John,")]), _vm._v(" 7-8, from which this section draws.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn91"
    }
  }, [_vm._v("91")]), _vm._v(". The statement of Papias is also recorded by Georgius Monachus (in the ninth century) and is supported by Syriac and African martyrologies.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn92"
    }
  }, [_vm._v("92")]), _vm._v(". On the relationship between the Beloved Disciple, the Elder, and the authorship of the Fourth Gospel and 1–3 John, cf. the discussion in Thomas, "), _c('i', [_vm._v("I John, 2 John, 3 John,")]), _vm._v(" 8-10, and in Hengel’s "), _c('i', [_vm._v("The Johannine Question.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn93"
    }
  }, [_vm._v("93")]), _vm._v(". G. D. Fee ("), _c('i', [_vm._v("Revelation")]), _vm._v(" [NCCS; Eugene, OR: Cascade Books, 2011]) makes a similar argument in defense of authorship by the son of Zebedee.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn94"
    }
  }, [_vm._v("94")]), _vm._v(". As for the likelihood of various leaders in the community bearing the same name, note that in the Fourth Gospel there were three women at the foot of the cross who shared the name Mary (19:25) and two disciples named Judas.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn95"
    }
  }, [_vm._v("95")]), _vm._v(". K. Deppermann, "), _c('i', [_vm._v("Melchior Hoffman: Social Unrest and Apocalyptic Visions in the Age of Reformation")]), _vm._v(" (ed. B. Drewery; trans. M. Wren; Edinburgh: T&T Clark, 1987), 254-62.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn96"
    }
  }, [_vm._v("96")]), _vm._v(". Deppermann, "), _c('i', [_vm._v("Melchior Hoffman,")]), _vm._v(" 336.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn97"
    }
  }, [_vm._v("97")]), _vm._v(". G. H. Williams, "), _c('i', [_vm._v("The Radical Reformation")]), _vm._v(" (Philadelphia: Westminster, 1962), 511, notes that the practice of polygamy might not be unrelated to the desire to fill out the number of 144,000 as quickly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn98"
    }
  }, [_vm._v("98")]), _vm._v(". A. W. Wainwright, "), _c('i', [_vm._v("Mysterious Apocalypse")]), _vm._v(" (Nashville: Abingdon, 1993), 90-92.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn99"
    }
  }, [_vm._v("99")]), _vm._v(". Much of what follows draws upon Vincent Bugliosi (with Curt Gentry), "), _c('i', [_vm._v("Helter Skelter: The True Story of the Manson Murders")]), _vm._v(" (New York: Norton, 1974 [1994]), 320-28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn100"
    }
  }, [_vm._v("100")]), _vm._v(". Barry Miles, "), _c('i', [_vm._v("Paul McCartney: Many Years from Now")]), _vm._v(" (New York: Henry Holt, 1997), 488-90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn101"
    }
  }, [_vm._v("101")]), _vm._v(". Much of what follows draws heavily from K. G. C. Newport, "), _c('i', [_vm._v("Apocalypse and Millennium: Studies in Biblical Eisegesis")]), _vm._v(" (Cambridge: Cambridge University Press, 2000), 197-236, who offers an excellent theological analysis of Koresh and the events that led to the horrible events of 19 April 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn102"
    }
  }, [_vm._v("102")]), _vm._v(". On this topic, cf. esp. J. Court, "), _c('i', [_vm._v("The Book of Revelation and the Johannine Apocalyptic Tradition")]), _vm._v(" (JSNTS 190; Sheffield: Sheffield Academic Press, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn103"
    }
  }, [_vm._v("103")]), _vm._v(". Court ("), _c('i', [_vm._v("The Book of Revelation and the Johannine Apocalyptic Tradition,")]), _vm._v(" 32-65) provides the Greek text of the "), _c('i', [_vm._v("2AJ,")]), _vm._v(" an English translation, as well as a useful commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn104"
    }
  }, [_vm._v("104")]), _vm._v(". For the evidence in favor of this later date, cf. A. Whealey, “The Apocryphal Apocalypse of John. A Byzantine Apocalypse from the Early Islamic Period,” "), _c('i', [_vm._v("JTS")]), _vm._v(" 53 (2002): 533-40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn105"
    }
  }, [_vm._v("105")]), _vm._v(". Court ("), _c('i', [_vm._v("The Book of Revelation and the Johannine Apocalyptic Tradition,")]), _vm._v(" 74-103) provides the Greek text of the "), _c('i', [_vm._v("AStJC,")]), _vm._v(" an English translation, as well as a useful commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn106"
    }
  }, [_vm._v("106")]), _vm._v(". Court ("), _c('i', [_vm._v("The Book of Revelation and the Johannine Apocalyptic Tradition,")]), _vm._v(" 108-31) provides the Greek text of the "), _c('i', [_vm._v("3AJ,")]), _vm._v(" an English translation, as well as a useful commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn107"
    }
  }, [_vm._v("107")]), _vm._v(". Court ("), _c('i', [_vm._v("The Book of Revelation and the Johannine Apocalyptic Tradition,")]), _vm._v(" 137-63) provides E. W. Budge’s English translation of the "), _c('i', [_vm._v("CAJ,")]), _vm._v(" as well as Court’s own useful commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn108"
    }
  }, [_vm._v("108")]), _vm._v(". J. Stevenson, "), _c('i', [_vm._v("The Catacombs: Life and Death in Early Christianity")]), _vm._v(" (Nashville: Thomas Nelson, 1985), 107-8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn109"
    }
  }, [_vm._v("109")]), _vm._v(". Stevenson, "), _c('i', [_vm._v("The Catacombs,")]), _vm._v(" 114-16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn110"
    }
  }, [_vm._v("110")]), _vm._v(". All these examples may be found in N. Grubb’s "), _c('i', [_vm._v("Revelations: Art of the Apocalypse")]), _vm._v(" (New York: Abbeville Press, 1997), a small but helpful introduction to the art of Revelation, and in a more exhaustive treatment by F. van der Meer, "), _c('i', [_vm._v("Apocalypse: Visions from the Book of Revelation in Western Art")]), _vm._v(" (New York: Alpine Fine Arts, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn111"
    }
  }, [_vm._v("111")]), _vm._v(". According to Beatus’s preface, these included the writings of “Jerome, Augustine, Ambrose, Fulgentius, Gregory, Tyconius, Irenaeus, Apringius and Isidore.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn112"
    }
  }, [_vm._v("112")]), _vm._v(". On the Beatus cycle, cf. van der Meer, "), _c('i', [_vm._v("Apocalypse,")]), _vm._v(" 108-27. Cf. also J. Williams, "), _c('i', [_vm._v("The Illustrated Beatus: A Corpus of the Illustrations of the Commentary on the Apocalypse")]), _vm._v(" (5 vols.; London: Harvey Miller Publishers, 1994-2003).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn113"
    }
  }, [_vm._v("113")]), _vm._v(". For an extensive discussion of van Eyck’s "), _c('i', [_vm._v("Adoration,")]), _vm._v(" cf. van der Meer, "), _c('i', [_vm._v("Apocalypse,")]), _vm._v(" 236-57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn114"
    }
  }, [_vm._v("114")]), _vm._v(". The autograph score of "), _c('i', [_vm._v("The Messiah")]), _vm._v(" bears these dates, written in German in Handel’s own hand, at the beginning and the end of the manuscript, respectively. J. Tobin, "), _c('i', [_vm._v("Handel at Work")]), _vm._v(" (New York: St. Martin’s Press, 1964), 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn115"
    }
  }, [_vm._v("115")]), _vm._v(". E. Smith, “Handel’s English Librettists,” in "), _c('i', [_vm._v("The Cambridge Companion to Handel")]), _vm._v(" (ed. D. Borrows; Cambridge: Cambridge University Press, 1997), 103.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn116"
    }
  }, [_vm._v("116")]), _vm._v(". A. Hicks, “Handel and the Idea of an Oratorio,” in "), _c('i', [_vm._v("The Cambridge Companion to Handel,")]), _vm._v(" 157, and D. Burrows, “Handel’s Oratorio Performances,” in "), _c('i', [_vm._v("The Cambridge Companion to Handel,")]), _vm._v(" 265.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn117"
    }
  }, [_vm._v("117")]), _vm._v(". Tobin, "), _c('i', [_vm._v("Handel at Work,")]), _vm._v(" 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn118"
    }
  }, [_vm._v("118")]), _vm._v(". On the eschatological views of Charles Wesley, cf. esp. Newport, "), _c('i', [_vm._v("Apocalypse and Millennium: Studies in Biblical Eisegesis,")]), _vm._v(" 119-49. Newport confines his fine study to the prose of Charles Wesley.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn119"
    }
  }, [_vm._v("119")]), _vm._v(". "), _c('i', [_vm._v("The Methodist Hymn-Book")]), _vm._v(" (London: Wesleyan Conference Office, 1904), 78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn120"
    }
  }, [_vm._v("120")]), _vm._v(". "), _c('i', [_vm._v("The Methodist Hymn-Book,")]), _vm._v(" 303.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn121"
    }
  }, [_vm._v("121")]), _vm._v(". "), _c('i', [_vm._v("The Methodist Hymn-Book,")]), _vm._v(" 321-22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn122"
    }
  }, [_vm._v("122")]), _vm._v(". Though the effective history of Revelation in the so-called mainline churches is often hard to discern, it has recently been demonstrated that the music known in this tradition reveals that, even here, Revelation is not without influence. Cf. the very helpful work of C. R. Koester, "), _c('i', [_vm._v("Revelation and the End of All Things")]), _vm._v(" (Grand Rapids: Eerdmans, 2001), esp. 33-38.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn123"
    }
  }, [_vm._v("123")]), _vm._v(". On this and other introductory questions, cf. esp. A. Putter, "), _c('i', [_vm._v("An Introduction to the")]), _vm._v(" Gawain-"), _c('i', [_vm._v("Poet")]), _vm._v(" (London: Longman, 1996), 1-37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn124"
    }
  }, [_vm._v("124")]), _vm._v(". Putter, "), _c('i', [_vm._v("An Introduction to the")]), _vm._v(" Gawain-"), _c('i', [_vm._v("Poet,")]), _vm._v(" 147.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn125"
    }
  }, [_vm._v("125")]), _vm._v(". "), _c('i', [_vm._v("The Pearl")]), _vm._v(" (trans. and ed. S. Deford et al.; New York: Appleton-Century-Croft, 1967), 65-67.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn126"
    }
  }, [_vm._v("126")]), _vm._v(". H. Bloom, "), _c('i', [_vm._v("Blake’s Apocalypse: A Study in Poetic Argument")]), _vm._v(" (Garden City, NY: Doubleday, 1963), 9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn127"
    }
  }, [_vm._v("127")]), _vm._v(". From "), _c('i', [_vm._v("The Complete Poetry and Prose of William Blake")]), _vm._v(" (ed. D. V. Erdman; New York: Doubleday, 1988), 118.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn128"
    }
  }, [_vm._v("128")]), _vm._v(". From "), _c('i', [_vm._v("The Complete Poetry and Prose of William Blake,")]), _vm._v(" 312-13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn129"
    }
  }, [_vm._v("129")]), _vm._v(". From "), _c('i', [_vm._v("The Complete Poetry and Prose of William Blake,")]), _vm._v(" 377.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn130"
    }
  }, [_vm._v("130")]), _vm._v(". "), _c('i', [_vm._v("Apostolic Faith")]), _vm._v(" (ed. William J. Seymour; Los Angeles, CA), 1.8 (May 1907): 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn131"
    }
  }, [_vm._v("131")]), _vm._v(". It is perhaps significant to note that, in contrast to numerous other films in which the effect of Revelation can be detected, the term “antichrist” appears nowhere in "), _c('i', [_vm._v("End of Days.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn132"
    }
  }, [_vm._v("132")]), _vm._v(". For a somewhat different analysis of this film, cf. R. Walsh, “On Finding a Non-American Revelation: "), _c('i', [_vm._v("End of Days")]), _vm._v(" and the Book of Revelation,” in "), _c('i', [_vm._v("Screening Scripture: Intertextual Connections between Scripture and Film")]), _vm._v(" (ed. G. Aichele and R. Walsh; Harrisburg, PA: Trinity Press International, 2002), 1-23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn133"
    }
  }, [_vm._v("133")]), _vm._v(". Cf. also movies based upon the "), _c('i', [_vm._v("Left Behind")]), _vm._v(" series of books by Tim LaHaye.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn134"
    }
  }, [_vm._v("134")]), _vm._v(". Cited according to the translation of R. E. Wallis in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" vol. 7 (Edinburgh: T&T Clark, 1989), 347.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn135"
    }
  }, [_vm._v("135")]), _vm._v(". Cited according to the translation of R. E. Wallis in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" 7:349.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn136"
    }
  }, [_vm._v("136")]), _vm._v(". Cited according to the translation of R. E. Wallis in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" 7:351.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn137"
    }
  }, [_vm._v("137")]), _vm._v(". Cited according to the translation of R. E. Wallis in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" 7:358.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn138"
    }
  }, [_vm._v("138")]), _vm._v(". Cited according to the translation of R. E. Wallis in "), _c('i', [_vm._v("The Ante-Nicene Fathers,")]), _vm._v(" 7:359.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn139"
    }
  }, [_vm._v("139")]), _vm._v(". The Venerable Bede (Venerable Beda), "), _c('i', [_vm._v("The Explanation of the Apocalypse")]), _vm._v(" (trans. E. Marshall; Oxford: James Parker, 1878).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn140"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn140"
    }
  }, [_vm._v("140")]), _vm._v(". On Bede and others, cf. the discussion by G. Kretschmar, "), _c('i', [_vm._v("Die Offenbarung des Johannes: Die Geschichte ihrer Auslegung im 1. Jahrtausend")]), _vm._v(" (CTM 9; Stuttgart: Calwer, 1985), 116-22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn141"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn141"
    }
  }, [_vm._v("141")]), _vm._v(". For the text, cf. Joachim of Fiore, "), _c('i', [_vm._v("Expositio in Apocalypsim")]), _vm._v(" (Frankfurt: Minerva, 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn142"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn142"
    }
  }, [_vm._v("142")]), _vm._v(". Cf. the website of the International Center for Joachimist Studies, in San Giovanni in Fiore, "), _c('a', {
    attrs: {
      "href": "http://www.centrostudigioachimiti.it/Benvenuti/benvenutieng.asp",
      "target": "_blank"
    }
  }, [_vm._v("www.centrostudigioachimiti.it/Benvenuti/benvenutieng.asp")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn143"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn143"
    }
  }, [_vm._v("143")]), _vm._v(". In addition to the website mentioned above, cf. also the helpful discussions of Joachim by Wainwright, "), _c('i', [_vm._v("Mysterious Apocalypse,")]), _vm._v(" 49-53, and J. Kovacs and C. Rowland, "), _c('i', [_vm._v("Revelation")]), _vm._v(" (Oxford: Blackwell, 2003), 17-19. For excerpts of Joachim’s work in English, cf. "), _c('i', [_vm._v("Apocalyptic Spirituality: Treatises and Letters of Lactantius, Adso of Montier-en-Der, Joachim of Fiore, The Franciscan Spirituals, Savonarola")]), _vm._v(" (New York: Paulist Press, 1979), 97-148.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn144"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn144"
    }
  }, [_vm._v("144")]), _vm._v(". A. A. Boesak, "), _c('i', [_vm._v("Comfort and Protest: Reflections on the Apocalypse of John on Patmos")]), _vm._v(" (Edinburgh: St. Andrew Press, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn145"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn145"
    }
  }, [_vm._v("145")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn146"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn146"
    }
  }, [_vm._v("146")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 38-39.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn147"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn147"
    }
  }, [_vm._v("147")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 61-62.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn148"
    }
  }, [_vm._v("148")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 68.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn149"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn149"
    }
  }, [_vm._v("149")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 72.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn150"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn150"
    }
  }, [_vm._v("150")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 115-16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn151"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn151"
    }
  }, [_vm._v("151")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 119.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn152"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn152"
    }
  }, [_vm._v("152")]), _vm._v(". Boesak, "), _c('i', [_vm._v("Comfort and Protest,")]), _vm._v(" 127-28.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f804d6e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 78
// module chunks = 0